/** @format */
/** Per-client configuration — add new client keys in each export when onboarding a client. */
import { Enviroment } from '../constants/enviroment-v2.constant';
import { FormatDateToHuman } from '../functions/format-date-to-human';

export const components_Antd_Alert_constants_style_constant__Dictionary = {
	CL: {
		default: 'alert-default-cl',
	},
	CLNARMA: {
		default: 'alert-default-cl',
	},
	CLANICX: {
		default: 'alert-default-cl',
	},
	CLGREEN: {
		default: 'alert-default-cl',
	},
	CLZUPHARMA: {
		default: 'alert-default-cl',
	},
	AR: {
		default: 'alert-default-ar',
	},
	MX: {
		default: 'alert-default-cl',
	},
};
export const components_Antd_Badge_constants_style_constant__Dictionary = {
	CL: {
		default: 'badge-default-cl',
	},
	CLNARMA: {
		default: 'badge-default-cl',
	},
	CLANICX: {
		default: 'badge-default-cl',
	},
	CLGREEN: {
		default: 'badge-default-cl',
	},
	CLZUPHARMA: {
		default: 'badge-default-cl',
	},
	MX: {
		default: 'badge-default-cl',
	},
	AR: {
		default: 'badge-default-ar',
	},
};
export const components_Antd_CheckBox_constants_style_constant__Dictionary = {
	CL: {
		default: 'checkbox-default-cl'
	},
	CLNARMA: {
		default: 'checkbox-default-cl'
	},
	CLANICX: {
		default: 'checkbox-default-cl',
	},
	CLGREEN: {
		default: 'checkbox-default-cl'
	},
	CLZUPHARMA: {
		default: 'checkbox-default-cl'
	},
	MX: {
		default: 'checkbox-default-cl'
	},
	AR: {
		default: 'checkbox-default-ar'
	},
};
export const components_Antd_CustomRadioGroup_constants_dictionary__Dictionary = {
	CL: {
		default: 'custom-radiogroup-cl',
	},
	CLNARMA: {
		default: 'custom-radiogroup-cl',
	},
	CLANICX: {
		default: 'custom-radiogroup-cl',
	},
	CLGREEN: {
		default: 'custom-radiogroup-cl',
	},
	CLZUPHARMA: {
		default: 'custom-radiogroup-cl',
	},
	MX: {
		default: 'custom-radiogroup-cl',
	},
	AR: {
		default: 'custom-radiogroup-ar',
	},
};
export const components_Antd_InputNumber_constants_style_constant__Dictionary = {
	CL: {
		default: 'input-number-cl',
		edit: 'input-number-cl-edit',
		disabled: 'input-number-cl-disabled',
		completed: 'input-number-cl-completed',
		error: 'input-number-cl-error',
	},
	CLNARMA: {
		default: 'input-number-cl',
		edit: 'input-number-cl-edit',
		disabled: 'input-number-cl-disabled',
		completed: 'input-number-cl-completed',
		error: 'input-number-cl-error',
	},
	CLANICX: {
		default: 'input-number-cl',
		edit: 'input-number-cl-edit',
		disabled: 'input-number-cl-disabled',
		completed: 'input-number-cl-completed',
		error: 'input-number-cl-error',
	},
	CLGREEN: {
		default: 'input-number-cl',
		edit: 'input-number-cl-edit',
		disabled: 'input-number-cl-disabled',
		completed: 'input-number-cl-completed',
		error: 'input-number-cl-error',
	},
	CLZUPHARMA: {
		default: 'input-number-cl',
		edit: 'input-number-cl-edit',
		disabled: 'input-number-cl-disabled',
		completed: 'input-number-cl-completed',
		error: 'input-number-cl-error',
	},
	MX: {
		default: 'input-number-cl',
		edit: 'input-number-cl-edit',
		disabled: 'input-number-cl-disabled',
		completed: 'input-number-cl-completed',
		error: 'input-number-cl-error',
	},
	AR: {
		default: 'input-number-ar',
		edit: 'input-number-ar-edit',
		disabled: 'input-number-ar-disabled',
		completed: 'input-number-ar-completed',
		error: 'input-number-ar-error',
	},
};
export const components_Antd_Modal_constants_style_constant__Dictionary = {
	CL: {
		default: 'modal-default-cl',
	},
	CLNARMA: {
		default: 'modal-default-cl',
	},
	CLANICX: {
		default: 'modal-default-cl',
	},
	CLGREEN: {
		default: 'modal-default-cl',
	},
	CLZUPHARMA: {
		default: 'modal-default-cl',
	},
	MX: {
		default: 'modal-default-cl',
	},
	AR: {
		default: 'modal-default-ar',
	},
};
export const components_Antd_Search_constants_style_constant__Dictionary = {
	CL: {
		default: 'input-search-cl',
		completed: 'input-search-cl-completed',
		defaultFill: 'input-search-cl-fill',
		completedFill: 'input-search-cl-completed-fill',
	},
	CLNARMA: {
		default: 'input-search-cl',
		completed: 'input-search-cl-completed',
		defaultFill: 'input-search-cl-fill',
		completedFill: 'input-search-cl-completed-fill',
	},
	CLANICX: {
		default: 'input-search-cl',
		completed: 'input-search-cl-completed',
		defaultFill: 'input-search-cl-fill',
		completedFill: 'input-search-cl-completed-fill',
	},
	CLGREEN: {
		default: 'input-search-cl',
		completed: 'input-search-cl-completed',
		defaultFill: 'input-search-cl-fill',
		completedFill: 'input-search-cl-completed-fill',
	},
	CLZUPHARMA: {
		default: 'input-search-cl',
		completed: 'input-search-cl-completed',
		defaultFill: 'input-search-cl-fill',
		completedFill: 'input-search-cl-completed-fill',
	},
	MX: {
		default: 'input-search-cl',
		completed: 'input-search-cl-completed',
		defaultFill: 'input-search-cl-fill',
		completedFill: 'input-search-cl-completed-fill',
	},
	AR: {
		default: 'input-search-ar',
		completed: 'input-search-ar-completed',
		defaultFill: 'input-search-ar-fill',
		completedFill: 'input-search-ar-completed-fill',
	},
};
export const components_Antd_Switch_constants_dictionary_constant__Dictionary = {
	CL: {
		default: 'custom-switch-cl',
	},
	CLNARMA: {
		default: 'custom-switch-cl',
	},
	CLANICX: {
		default: 'custom-switch-cl',
	},
	CLGREEN: {
		default: 'custom-switch-cl',
	},
	CLZUPHARMA: {
		default: 'custom-switch-cl',
	},
	MX: {
		default: 'custom-switch-cl',
	},
	AR: {
		default: 'custom-switch-ar',
	},
};
export const components_Antd_Table_dictionary__Dictionary = {
	CL: {
		default: 'custom-table-cl',
	},
	CLNARMA: {
		default: 'custom-table-cl',
	},
	CLANICX: {
		default: 'custom-table-cl',
	},
	CLGREEN: {
		default: 'custom-table-cl',
	},
	CLZUPHARMA: {
		default: 'custom-table-cl',
	},
	MX: {
		default: 'custom-table-cl',
	},
	AR: {
		default: 'custom-table-ar',
	},
};
export const components_Antd_Tabs_dictionary__Dictionary = {
	CL: {
		default: 'custom-tabs-cl'
	},
	CLNARMA: {
		default: 'custom-tabs-cl'
	},
	CLANICX: {
		default: 'custom-tabs-cl',
	},
	CLGREEN: {
		default: 'custom-tabs-cl'
	},
	CLZUPHARMA: {
		default: 'custom-tabs-cl'
	},
	MX: {
		default: 'custom-tabs-cl'
	},
	AR: {
		default: 'custom-tabs-ar'
	},
};
export const components_Antd_TextArea_constants_dictionary_constant__Dictionary = {
	CL: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	CLNARMA: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	CLANICX: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	CLGREEN: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	CLZUPHARMA: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	MX: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	AR: {
		default: "custom-input-ar",
		edit: "custom-input-ar-edit",
		completed: "custom-input-ar-completed",
	},
};
export const config_constants_image_country_constant__CountryImage = {
	CL: {
		favicon: Enviroment.BUCKET_MARKETPLACE + '/CL/favicon.png',
		notFound: Enviroment.BUCKET_MARKETPLACE + '/CL/not-found.png',
	},
	CLNARMA: {
		favicon: Enviroment.BUCKET_MARKETPLACE + '/CL/favicon.png',
		notFound: Enviroment.BUCKET_MARKETPLACE + '/CL/not-found.png',
	},
	CLANICX: {
		favicon: Enviroment.BUCKET_MARKETPLACE + '/CL/favicon.png',
		notFound: Enviroment.BUCKET_MARKETPLACE + '/CL/not-found.png',
	},
	CLGREEN: {
		favicon: Enviroment.BUCKET_MARKETPLACE + '/CL/favicon.png',
		notFound: Enviroment.BUCKET_MARKETPLACE + '/CL/not-found.png',
	},
	CLZUPHARMA: {
		favicon: Enviroment.BUCKET_MARKETPLACE + '/CL/favicon.png',
		notFound: Enviroment.BUCKET_MARKETPLACE + '/CL/not-found.png',
	},
	AR: {
		favicon: Enviroment.BUCKET_MARKETPLACE + '/AR/favicon.png',
		notFound: Enviroment.BUCKET_MARKETPLACE + '/AR/not-found.png',
	},
	MX: {
		favicon: Enviroment.BUCKET_MARKETPLACE + '/MX/favicon.png',
		notFound: Enviroment.BUCKET_MARKETPLACE + '/MX/not-found.png',
	},
};
export const config_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },
};
export const config_constants_status_order_constant__StatusOrder = {
	CL: {
		1: {
			title: 'Por aprobar',
			description:
				'Antes de aprobar la orden y continuar, verifica la receta. Puedes rechazarla en caso de error y solicitar que se reenvíe correctamente.',
		},
		101: {
			title: 'Mediación',
			description: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprueba la orden para continuar.',
		},
		2: {
			title: 'Aprobada',
			description: 'La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.',
		},
		201: {
			title: 'Por confirmar',
			description:
				'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
		},
		3: {
			title: 'En proceso de empacado',
			description: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
		},
		4: {
			title: 'Listo para retiro',
			description:
				'En caso de Despacho: El pedido ya fue armado y está listo para ser retirado por el mensajero.                        En caso de Retiro en farmacia: El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.',
		},
		5: {
			title: 'Pedido en camino',
			description: 'El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.',
		},
		6: {
			title: 'Pedido entregado',
			description: 'El pedido fue entregado',
		},
		7: {
			title: 'Receta anulada',
			description: 'Receta anulada',
		},
		8: {
			title: 'Pedido anulado',
			description: ' El pedido fue anulado',
		},
		9: {
			title: 'Pedido confirmado',
			description: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
	},
	CLNARMA: {
		1: {
			title: 'Por aprobar',
			description:
				'Antes de aprobar la orden y continuar, verifica la receta. Puedes rechazarla en caso de error y solicitar que se reenvíe correctamente.',
		},
		101: {
			title: 'Mediación',
			description: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprueba la orden para continuar.',
		},
		2: {
			title: 'Aprobada',
			description: 'La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.',
		},
		201: {
			title: 'Por confirmar',
			description:
				'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
		},
		3: {
			title: 'En proceso de empacado',
			description: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
		},
		4: {
			title: 'Listo para retiro',
			description:
				'En caso de Despacho: El pedido ya fue armado y está listo para ser retirado por el mensajero.                        En caso de Retiro en farmacia: El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.',
		},
		5: {
			title: 'Pedido en camino',
			description: 'El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.',
		},
		6: {
			title: 'Pedido entregado',
			description: 'El pedido fue entregado',
		},
		7: {
			title: 'Receta anulada',
			description: 'Receta anulada',
		},
		8: {
			title: 'Pedido anulado',
			description: ' El pedido fue anulado',
		},
		9: {
			title: 'Pedido confirmado',
			description: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
	},
	CLANICX: {
		1: {
			title: 'Por aprobar',
			description:
				'Antes de aprobar la orden y continuar, verifica la receta. Puedes rechazarla en caso de error y solicitar que se reenvíe correctamente.',
		},
		101: {
			title: 'Mediación',
			description: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprueba la orden para continuar.',
		},
		2: {
			title: 'Aprobada',
			description: 'La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.',
		},
		201: {
			title: 'Por confirmar',
			description:
				'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
		},
		3: {
			title: 'En proceso de empacado',
			description: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
		},
		4: {
			title: 'Listo para retiro',
			description:
				'En caso de Despacho: El pedido ya fue armado y está listo para ser retirado por el mensajero.                        En caso de Retiro en farmacia: El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.',
		},
		5: {
			title: 'Pedido en camino',
			description: 'El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.',
		},
		6: {
			title: 'Pedido entregado',
			description: 'El pedido fue entregado',
		},
		7: {
			title: 'Receta anulada',
			description: 'Receta anulada',
		},
		8: {
			title: 'Pedido anulado',
			description: ' El pedido fue anulado',
		},
		9: {
			title: 'Pedido confirmado',
			description: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
	},
	CLGREEN: {
		1: {
			title: 'Por aprobar',
			description:
				'Antes de aprobar la orden y continuar, verifica la receta. Puedes rechazarla en caso de error y solicitar que se reenvíe correctamente.',
		},
		101: {
			title: 'Mediación',
			description: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprueba la orden para continuar.',
		},
		2: {
			title: 'Aprobada',
			description: 'La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.',
		},
		201: {
			title: 'Por confirmar',
			description:
				'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
		},
		3: {
			title: 'En proceso de empacado',
			description: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
		},
		4: {
			title: 'Listo para retiro',
			description:
				'En caso de Despacho: El pedido ya fue armado y está listo para ser retirado por el mensajero.                        En caso de Retiro en farmacia: El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.',
		},
		5: {
			title: 'Pedido en camino',
			description: 'El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.',
		},
		6: {
			title: 'Pedido entregado',
			description: 'El pedido fue entregado',
		},
		7: {
			title: 'Receta anulada',
			description: 'Receta anulada',
		},
		8: {
			title: 'Pedido anulado',
			description: ' El pedido fue anulado',
		},
		9: {
			title: 'Pedido confirmado',
			description: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
	},
	CLZUPHARMA: {
		1: {
			title: 'Por aprobar',
			description:
				'Antes de aprobar la orden y continuar, verifica la receta. Puedes rechazarla en caso de error y solicitar que se reenvíe correctamente.',
		},
		101: {
			title: 'Mediación',
			description: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprueba la orden para continuar.',
		},
		2: {
			title: 'Aprobada',
			description: 'La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.',
		},
		201: {
			title: 'Por confirmar',
			description:
				'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
		},
		3: {
			title: 'En proceso de empacado',
			description: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
		},
		4: {
			title: 'Listo para retiro',
			description:
				'En caso de Despacho: El pedido ya fue armado y está listo para ser retirado por el mensajero.                        En caso de Retiro en farmacia: El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.',
		},
		5: {
			title: 'Pedido en camino',
			description: 'El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.',
		},
		6: {
			title: 'Pedido entregado',
			description: 'El pedido fue entregado',
		},
		7: {
			title: 'Receta anulada',
			description: 'Receta anulada',
		},
		8: {
			title: 'Pedido anulado',
			description: ' El pedido fue anulado',
		},
		9: {
			title: 'Pedido confirmado',
			description: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
	},
	MX: {
		1: {
			title: 'Por aprobar',
			description:
				'Antes de aprobar la orden y continuar, verifica la receta. Puedes rechazarla en caso de error y solicitar que se reenvíe correctamente.',
		},
		101: {
			title: 'Mediación',
			description: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprueba la orden para continuar.',
		},
		2: {
			title: 'Aprobada',
			description: 'La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.',
		},
		201: {
			title: 'Por confirmar',
			description:
				'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
		},
		3: {
			title: 'En proceso de empacado',
			description: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
		},
		4: {
			title: 'Listo para retiro',
			description:
				'En caso de Despacho: El pedido ya fue armado y está listo para ser retirado por el mensajero.                        En caso de Retiro en farmacia: El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.',
		},
		5: {
			title: 'Pedido en camino',
			description: 'El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.',
		},
		6: {
			title: 'Pedido entregado',
			description: 'El pedido fue entregado',
		},
		7: {
			title: 'Receta anulada',
			description: 'Receta anulada',
		},
		8: {
			title: 'Pedido anulado',
			description: ' El pedido fue anulado',
		},
		9: {
			title: 'Pedido confirmado',
			description: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
	},
	AR: {
		1: {
			title: 'Por aprobar',
			description:
				'Antes de aprobar la orden y continuar, verifica la receta. Puedes rechazarla en caso de error y solicitar que se reenvíe correctamente.',
		},
		101: {
			title: 'Mediación',
			description: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprobá la orden para continuar.',
		},
		2: {
			title: 'Aprobada',
			description: '¡Tenés un nuevo pedido! Dale a continuar para comenzar el proceso.',
		},
		201: {
			title: 'Por confirmar',
			description:
				'Antes de continuar verificá que cuentes con el stock de los productos. En caso  de un faltante contactate con el cliente para ofrecerle una solución.',
		},
		3: {
			title: 'En proceso de armado',
			description:
				'Ya podés armar la orden. Asegurate de tener el pedido armado antes de continuar, ya que se notificará que está listo para su retiro.',
		},
		4: {
			title: 'Listo para retiro',
			description:
				' En caso de retiro en tienda: Ya se le notificó al cliente que el paquete ya está listo para retirar.                              De ser envío a domicilio: Ya se le avisó a la moto para que retire el paquete.',
		},
		5: {
			title: 'Pedido en camino',
			description: 'La moto ya retiró el paquete y se encuentra en camino al domicilio de entrega.',
		},
		6: {
			title: 'Pedido entregado',
			description: 'El pedido fue entregado',
		},
		7: {
			title: 'Receta anulada',
			description: 'Receta anulada',
		},
		8: {
			title: 'Pedido cancelado',
			description: 'El pedido fue cancelado y se le devolvió el dinero al cliente.',
		},
		9: {
			title: 'Entrega confirmada',
			description: 'El cliente confirmó la entrega del pedido.',
		},
	},
};
export const config_functions_format_number_function__FormatNumber = {
	CL: {
		handleFormat: (number) => {
			const format = new Intl.NumberFormat('es-CL', {
				style: 'currency',
				currency: 'CLP',
			}).format(number);

			return format;
		},
	},
	CLNARMA: {
		handleFormat: (number) => {
			const format = new Intl.NumberFormat('es-CL', {
				style: 'currency',
				currency: 'CLP',
			}).format(number);

			return format;
		},
	},
	CLANICX: {
		handleFormat: (number) => {
			const format = new Intl.NumberFormat('es-CL', {
				style: 'currency',
				currency: 'CLP',
			}).format(number);

			return format;
		},
	},
	CLGREEN: {
		handleFormat: (number) => {
			const format = new Intl.NumberFormat('es-CL', {
				style: 'currency',
				currency: 'CLP',
			}).format(number);

			return format;
		},
	},
	CLZUPHARMA: {
		handleFormat: (number) => {
			const format = new Intl.NumberFormat('es-CL', {
				style: 'currency',
				currency: 'CLP',
			}).format(number);

			return format;
		},
	},
	MX: {
		handleFormat: (number) => {
			const format = new Intl.NumberFormat('es-MX', {
				style: 'currency',
				currency: 'MXN',
			}).format(number);

			return format;
		},
	},
	AR: {
		handleFormat: (number) => {
			const format = new Intl.NumberFormat('es-AR', {
				style: 'currency',
				currency: 'ARS',
			}).format(number);

			return format;
		},
	},
};
export const config_functions_transform_iso__TransformIso = {
	CL: {
		handleFormat: (item) => {
			let dateTime = new Date(item);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	CLNARMA: {
		handleFormat: (item) => {
			let dateTime = new Date(item);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	CLANICX: {
		handleFormat: (item) => {
			let dateTime = new Date(item);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	CLGREEN: {
		handleFormat: (item) => {
			let dateTime = new Date(item);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	CLZUPHARMA: {
		handleFormat: (item) => {
			let dateTime = new Date(item);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	MX: {
		handleFormat: (item) => {
			let dateTime = new Date(item);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Mexico_City' });
			return FormatDateToHuman(localTime);
		},
	},
	AR: {
		handleFormat: (item) => {
			let dateTime = new Date(item);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' });
			return FormatDateToHuman(localTime);
		},
	},
};
export const config_functions_transform_unix__TransformUnix = {
	CL: {
		handleFormat: (item) => {
			let dateTime = new Date(item * 1000);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	CLNARMA: {
		handleFormat: (item) => {
			let dateTime = new Date(item * 1000);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	CLANICX: {
		handleFormat: (item) => {
			let dateTime = new Date(item);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	CLGREEN: {
		handleFormat: (item) => {
			let dateTime = new Date(item * 1000);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	CLZUPHARMA: {
		handleFormat: (item) => {
			let dateTime = new Date(item * 1000);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Santiago' });
			return FormatDateToHuman(localTime);
		},
	},
	AR: {
		handleFormat: (item) => {
			let dateTime = new Date(item * 1000);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' });
			return FormatDateToHuman(localTime);
		},
	},
	MX: {
		handleFormat: (item) => {
			let dateTime = new Date(item * 1000);
			let localTime = dateTime.toLocaleString('en-US', { timeZone: 'America/Mexico_City' });
			return FormatDateToHuman(localTime);
		},
	},
	
};
export const v2_components_Antd_Alert_constants_style_constant__Dictionary = {
	CL: {
		default: 'alert-default-cl',
	},
	CLNARMA: {
		default: 'alert-default-cl',
	},
	CLANICX: {
		default: 'alert-default-cl',
	},
	CLGREEN: {
		default: 'alert-default-cl',
	},
	CLZUPHARMA: {
		default: 'alert-default-cl',
	},
	MX: {
		default: 'alert-default-cl',
	},
	AR: {
		default: 'alert-default-ar',
	},
};
export const v2_components_Antd_Badge_constants_style_constant__Dictionary = {
	CL: {
		default: 'badge-default-cl',
	},
	CLNARMA: {
		default: 'badge-default-cl',
	},
	CLANICX: {
		default: 'badge-default-cl',
	},
	CLGREEN: {
		default: 'badge-default-cl',
	},
	CLZUPHARMA: {
		default: 'badge-default-cl',
	},
	MX: {
		default: 'badge-default-cl',
	},
	AR: {
		default: 'badge-default-ar',
	},
};
export const v2_components_Antd_Button_constants_style_constant__Dictionary = {
	CL: {
		default: 'button-default-cl',
	},
	CLNARMA: {
		default: 'button-default-cl',
	},
	CLANICX: {
		default: 'button-default-cl',
	},
	CLGREEN: {
		default: 'button-default-cl',
	},
	CLZUPHARMA: {
		default: 'button-default-cl',
	},
	MX: {
		default: 'button-default-cl',
	},
	AR: {
		default: 'button-default-ar',
	},
};
export const v2_components_Antd_Checkbox_constants_style_constant__Dictionary = {
	CL: {
		default: 'checkbox-default-cl'
	},
	CLNARMA: {
		default: 'checkbox-default-cl'
	},
	CLANICX: {
		default: 'checkbox-default-cl',
	},
	CLGREEN: {
		default: 'checkbox-default-cl'
	},
	CLZUPHARMA: {
		default: 'checkbox-default-cl'
	},
	MX: {
		default: 'checkbox-default-cl'
	},
	AR: {
		default: 'checkbox-default-ar'
	},
};
export const v2_components_Antd_Modal_constants_style_constant__Dictionary = {
	CL: {
		default: 'modal-default-cl',
	},
	CLNARMA: {
		default: 'modal-default-cl',
	},
	CLANICX: {
		default: 'modal-default-cl',
	},
	CLGREEN: {
		default: 'modal-default-cl',
	},
	CLZUPHARMA: {
		default: 'modal-default-cl',
	},
	MX: {
		default: 'modal-default-cl',
	},
	AR: {
		default: 'modal-default-ar',
	},
};
export const v2_components_Antd_Pagination_dictionary__Dictionary = {
	CL: {
		default: 'custom-pagination-cl',
	},
	CLNARMA: {
		default: 'custom-pagination-cl',
	},
	CLANICX: {
		default: 'custom-pagination-cl',
	},
	CLGREEN: {
		default: 'custom-pagination-cl',
	},
	CLZUPHARMA: {
		default: 'custom-pagination-cl',
	},
	MX: {
		default: 'custom-pagination-cl',
	},
	AR: {
		default: 'custom-pagination-ar',
	},
};
export const v2_components_Antd_Radio_constants_style_constant__Dictionary = {
	CL: {
		default: 'radio-default-cl'
	},
	CLNARMA: {
		default: 'radio-default-cl'
	},
	CLANICX: {
		default: 'radio-default-cl',
	},
	CLGREEN: {
		default: 'radio-default-cl'
	},
	CLZUPHARMA: {
		default: 'radio-default-cl'
	},
	MX: {
		default: 'radio-default-cl'
	},
	AR: {
		default: 'radio-default-ar'
	},
};
export const v2_components_Antd_RadioGroup_dictionary__Dictionary = {
	CL: {
		default: 'custom-radiogroup-cl',
	},
	CLANICX: {
		default: 'custom-radiogroup-cl',
	},
	MX: {
		default: 'custom-radiogroup-cl',
	},
	AR: {
		default: 'custom-radiogroup-ar',
	},
};
export const v2_components_Antd_Table_dictionary__Dictionary = {
	CL: {
		default: 'custom-table-cl',
	},
	CLNARMA: {
		default: 'custom-table-cl',
	},
	CLANICX: {
		default: 'custom-table-cl',
	},
	CLGREEN: {
		default: 'custom-table-cl',
	},
	CLZUPHARMA: {
		default: 'custom-table-cl',
	},
	MX: {
		default: 'custom-table-cl',
	},
	AR: {
		default: 'custom-table-ar',
	},
};
export const v2_components_Antd_Tabs_dictionary__Dictionary = {
	CL: {
		default: 'custom-tabs-cl'
	},
	CLNARMA: {
		default: 'custom-tabs-cl'
	},
	CLANICX: {
		default: 'custom-tabs-cl',
	},
	CLGREEN: {
		default: 'custom-tabs-cl'
	},
	CLZUPHARMA: {
		default: 'custom-tabs-cl'
	},
	MX: {
		default: 'custom-tabs-cl'
	},
	AR: {
		default: 'custom-tabs-ar'
	},
};
export const v2_components_Antd_TextArea_dictionary__Dictionary = {
	CL: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	CLNARMA: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	CLANICX: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	CLGREEN: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	CLZUPHARMA: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	MX: {
		default: "custom-input-cl",
		edit: "custom-input-cl-edit",
		completed: "custom-input-cl-completed",
	},
	AR: {
		default: "custom-input-ar",
		edit: "custom-input-ar-edit",
		completed: "custom-input-ar-completed",
	},
};
export const v2_components_Search_country__Country = {
	CL: {
		handleIndex: () => {
				return Enviroment.ELASTIC_SEARCH_PRODUCTS;
			},
		handleQuery: (query) => {
			return query;
		},
		handleFilters: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								available: 0,
							},
						],
					},
				],
			};
			return filters;
		},
		handleFiltersNarma: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								stock: 0,
							},
						],
					},
				],
			};
			return filters;
		},
	},
	CLNARMA: {
		handleIndex: () => {
				return Enviroment.ELASTIC_PRODUCTS;
			},
		handleQuery: (query) => {
			return query;
		},
		handleFilters: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								stock: 0,
							},
						],
					},
				],
			};
			return filters;
		},
		handleFiltersNarma: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								stock: 0,
							},
						],
					},
				],
			};
			return filters;
		},
	},
	CLANICX: {
		handleIndex: () => {
				return Enviroment.ELASTIC_PRODUCTS;
			},
		handleQuery: (query) => {
			return query;
		},
		handleFilters: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								stock: 0,
							},
						],
					},
				],
			};
			return filters;
		},
		handleFiltersNarma: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								stock: 0,
							},
						],
					},
				],
			};
			return filters;
		},
	},
	CLGREEN: {
		handleIndex: () => {
				return Enviroment.ELASTIC_PRODUCTS;
			},
		handleQuery: (query) => {
			return query;
		},
		handleFilters: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								stock: 0,
							},
						],
					},
				],
			};
			return filters;
		},
		handleFiltersNarma: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								stock: 0,
							},
						],
					},
				],
			};
			return filters;
		},
	},
	CLZUPHARMA: {
		handleIndex: () => {
				return Enviroment.ELASTIC_PRODUCTS;
			},
		handleQuery: (query) => {
			return query;
		},
		handleFilters: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								stock: 0,
							},
						],
					},
				],
			};
			return filters;
		},
		handleFiltersNarma: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								stock: 0,
							},
						],
					},
				],
			};
			return filters;
		},
	},
	MX: {
		handleIndex: () => {
			return Enviroment.ELASTIC_SEARCH_PRODUCTS;
		},
		handleQuery: (query) => {
			return query;
		},
		handleFilters: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								available: 0,
							},
						],
					},
				],
			};
			return filters;
		},
	},
	AR: {
		handleIndex: () => {
			return Enviroment.ELASTIC_SEARCH_PRODUCTS;
		},
		handleQuery: (query) => {
			return query;
		},
		handleFilters: (query) => {
			let filters = {
				all: [
					{
						none: [
							{
								available: 0,
							},
						],
					},
				],
			};
			return filters;
		},
	},
};
export const v2_components_SideBar_constants_country_constant__Country = {
	CL: {
		order: {
			'order-main': 'Ordenes CL',
			'order-pending': 'Pendiente CL',
			'order-aproved': 'Aprobadas CL',
		},
		tracking: {
			'tracking-main': 'Tracking CL',
			'tracking-general': 'General CL',
			'tracking-individual': 'Mi Farmacia CL',
		},
		pharolgo: {
			'pharolgo-main': 'Pharol GO CL',
			'pharolgo-polygons': 'Mis Polígonos CL',
			'pharolgo-drivers': 'Mis Despachadores CL',
		},
		antd: {
			'antd-main': 'Mis Componentes CL',
			'antd-input': 'Input CL',
			'antd-button': 'Button CL',
			'antd-select': 'Select CL',
			'antd-alert': 'Alert CL',
			'antd-badge': 'Badge CL',
			'antd-table': 'Tabla CL',
			'antd-tabs': 'Tabs CL',
			'antd-text-area': 'Text Area CL',
			'antd-collapse': 'Collapse CL',
			'antd-checkbox': 'Checkbox CL',
			'antd-dropdown': 'Dropdown CL',
			'antd-input-number': 'Input Number CL',
			'antd-modal': 'Modal CL',
			'antd-radio': 'Radio CL',
			'antd-radio-group': 'Radio group CL',
			'antd-switch': 'Switch/Interruptor CL',
			'antd-textarea': 'Textarea CL',
			'antd-breadcrumbs': 'Breadcrumbs CL',
			'antd-search': 'Search CL',
		},
		pharmacyLocals: {
			'pharmacy-locals-main': 'Farmacias CL',
		},
		notifications: {
			'notification-main': 'Notificaciones CL',
		},
		migration: {
			'migration-main': 'Migración CL',
		},
		reserve: {
			'reserve-main': 'Reservas CL',
		},
		recipeHistory: {
			'recipe-history-main': 'Historial de recetas CL',
		},
		modalDirections: {
			'modal-directions-main': 'Modal de direcciones CL',
		},
		exampleAxios: {
			'example-axios-main': 'Ejemplo(Axios) CL',
		},
		search: {
			'search-main': 'Autocomplete CL',
		},
	},
	CLNARMA: {
		order: {
			'order-main': 'Ordenes CL',
			'order-pending': 'Pendiente CL',
			'order-aproved': 'Aprobadas CL',
		},
		tracking: {
			'tracking-main': 'Tracking CL',
			'tracking-general': 'General CL',
			'tracking-individual': 'Mi Farmacia CL',
		},
		pharolgo: {
			'pharolgo-main': 'Pharol GO CL',
			'pharolgo-polygons': 'Mis Polígonos CL',
			'pharolgo-drivers': 'Mis Despachadores CL',
		},
		antd: {
			'antd-main': 'Mis Componentes CL',
			'antd-input': 'Input CL',
			'antd-button': 'Button CL',
			'antd-select': 'Select CL',
			'antd-alert': 'Alert CL',
			'antd-badge': 'Badge CL',
			'antd-table': 'Tabla CL',
			'antd-tabs': 'Tabs CL',
			'antd-text-area': 'Text Area CL',
			'antd-collapse': 'Collapse CL',
			'antd-checkbox': 'Checkbox CL',
			'antd-dropdown': 'Dropdown CL',
			'antd-input-number': 'Input Number CL',
			'antd-modal': 'Modal CL',
			'antd-radio': 'Radio CL',
			'antd-radio-group': 'Radio group CL',
			'antd-switch': 'Switch/Interruptor CL',
			'antd-textarea': 'Textarea CL',
			'antd-breadcrumbs': 'Breadcrumbs CL',
			'antd-search': 'Search CL',
		},
		pharmacyLocals: {
			'pharmacy-locals-main': 'Farmacias CL',
		},
		notifications: {
			'notification-main': 'Notificaciones CL',
		},
		migration: {
			'migration-main': 'Migración CL',
		},
		reserve: {
			'reserve-main': 'Reservas CL',
		},
		recipeHistory: {
			'recipe-history-main': 'Historial de recetas CL',
		},
		modalDirections: {
			'modal-directions-main': 'Modal de direcciones CL',
		},
		exampleAxios: {
			'example-axios-main': 'Ejemplo(Axios) CL',
		},
		search: {
			'search-main': 'Autocomplete CL',
		},
	},
	CLANICX: {
		order: {
			'order-main': 'Ordenes CL',
			'order-pending': 'Pendiente CL',
			'order-aproved': 'Aprobadas CL',
		},
		tracking: {
			'tracking-main': 'Tracking CL',
			'tracking-general': 'General CL',
			'tracking-individual': 'Mi Farmacia CL',
		},
		pharolgo: {
			'pharolgo-main': 'Pharol GO CL',
			'pharolgo-polygons': 'Mis Polígonos CL',
			'pharolgo-drivers': 'Mis Despachadores CL',
		},
		antd: {
			'antd-main': 'Mis Componentes CL',
			'antd-input': 'Input CL',
			'antd-button': 'Button CL',
			'antd-select': 'Select CL',
			'antd-alert': 'Alert CL',
			'antd-badge': 'Badge CL',
			'antd-table': 'Tabla CL',
			'antd-tabs': 'Tabs CL',
			'antd-text-area': 'Text Area CL',
			'antd-collapse': 'Collapse CL',
			'antd-checkbox': 'Checkbox CL',
			'antd-dropdown': 'Dropdown CL',
			'antd-input-number': 'Input Number CL',
			'antd-modal': 'Modal CL',
			'antd-radio': 'Radio CL',
			'antd-radio-group': 'Radio group CL',
			'antd-switch': 'Switch/Interruptor CL',
			'antd-textarea': 'Textarea CL',
			'antd-breadcrumbs': 'Breadcrumbs CL',
			'antd-search': 'Search CL',
		},
		pharmacyLocals: {
			'pharmacy-locals-main': 'Farmacias CL',
		},
		notifications: {
			'notification-main': 'Notificaciones CL',
		},
		migration: {
			'migration-main': 'Migración CL',
		},
		reserve: {
			'reserve-main': 'Reservas CL',
		},
		recipeHistory: {
			'recipe-history-main': 'Historial de recetas CL',
		},
		modalDirections: {
			'modal-directions-main': 'Modal de direcciones CL',
		},
		exampleAxios: {
			'example-axios-main': 'Ejemplo(Axios) CL',
		},
		search: {
			'search-main': 'Autocomplete CL',
		},
	},
	CLGREEN: {
		order: {
			'order-main': 'Ordenes CL',
			'order-pending': 'Pendiente CL',
			'order-aproved': 'Aprobadas CL',
		},
		tracking: {
			'tracking-main': 'Tracking CL',
			'tracking-general': 'General CL',
			'tracking-individual': 'Mi Farmacia CL',
		},
		pharolgo: {
			'pharolgo-main': 'Pharol GO CL',
			'pharolgo-polygons': 'Mis Polígonos CL',
			'pharolgo-drivers': 'Mis Despachadores CL',
		},
		antd: {
			'antd-main': 'Mis Componentes CL',
			'antd-input': 'Input CL',
			'antd-button': 'Button CL',
			'antd-select': 'Select CL',
			'antd-alert': 'Alert CL',
			'antd-badge': 'Badge CL',
			'antd-table': 'Tabla CL',
			'antd-tabs': 'Tabs CL',
			'antd-text-area': 'Text Area CL',
			'antd-collapse': 'Collapse CL',
			'antd-checkbox': 'Checkbox CL',
			'antd-dropdown': 'Dropdown CL',
			'antd-input-number': 'Input Number CL',
			'antd-modal': 'Modal CL',
			'antd-radio': 'Radio CL',
			'antd-radio-group': 'Radio group CL',
			'antd-switch': 'Switch/Interruptor CL',
			'antd-textarea': 'Textarea CL',
			'antd-breadcrumbs': 'Breadcrumbs CL',
			'antd-search': 'Search CL',
		},
		pharmacyLocals: {
			'pharmacy-locals-main': 'Farmacias CL',
		},
		notifications: {
			'notification-main': 'Notificaciones CL',
		},
		migration: {
			'migration-main': 'Migración CL',
		},
		reserve: {
			'reserve-main': 'Reservas CL',
		},
		recipeHistory: {
			'recipe-history-main': 'Historial de recetas CL',
		},
		modalDirections: {
			'modal-directions-main': 'Modal de direcciones CL',
		},
		exampleAxios: {
			'example-axios-main': 'Ejemplo(Axios) CL',
		},
		search: {
			'search-main': 'Autocomplete CL',
		},
	},
	CLZUPHARMA: {
		order: {
			'order-main': 'Ordenes CL',
			'order-pending': 'Pendiente CL',
			'order-aproved': 'Aprobadas CL',
		},
		tracking: {
			'tracking-main': 'Tracking CL',
			'tracking-general': 'General CL',
			'tracking-individual': 'Mi Farmacia CL',
		},
		pharolgo: {
			'pharolgo-main': 'Pharol GO CL',
			'pharolgo-polygons': 'Mis Polígonos CL',
			'pharolgo-drivers': 'Mis Despachadores CL',
		},
		antd: {
			'antd-main': 'Mis Componentes CL',
			'antd-input': 'Input CL',
			'antd-button': 'Button CL',
			'antd-select': 'Select CL',
			'antd-alert': 'Alert CL',
			'antd-badge': 'Badge CL',
			'antd-table': 'Tabla CL',
			'antd-tabs': 'Tabs CL',
			'antd-text-area': 'Text Area CL',
			'antd-collapse': 'Collapse CL',
			'antd-checkbox': 'Checkbox CL',
			'antd-dropdown': 'Dropdown CL',
			'antd-input-number': 'Input Number CL',
			'antd-modal': 'Modal CL',
			'antd-radio': 'Radio CL',
			'antd-radio-group': 'Radio group CL',
			'antd-switch': 'Switch/Interruptor CL',
			'antd-textarea': 'Textarea CL',
			'antd-breadcrumbs': 'Breadcrumbs CL',
			'antd-search': 'Search CL',
		},
		pharmacyLocals: {
			'pharmacy-locals-main': 'Farmacias CL',
		},
		notifications: {
			'notification-main': 'Notificaciones CL',
		},
		migration: {
			'migration-main': 'Migración CL',
		},
		reserve: {
			'reserve-main': 'Reservas CL',
		},
		recipeHistory: {
			'recipe-history-main': 'Historial de recetas CL',
		},
		modalDirections: {
			'modal-directions-main': 'Modal de direcciones CL',
		},
		exampleAxios: {
			'example-axios-main': 'Ejemplo(Axios) CL',
		},
		search: {
			'search-main': 'Autocomplete CL',
		},
	},
	MX: {
		order: {
			'order-main': 'Ordenes MX',
			'order-pending': 'Pendiente MX',
			'order-aproved': 'Aprobadas MX',
		},
		tracking: {
			'tracking-main': 'Tracking MX',
			'tracking-general': 'General MX',
			'tracking-individual': 'Mi Farmacia MX',
		},
		pharolgo: {
			'pharolgo-main': 'Pharol GO MX',
			'pharolgo-polygons': 'Mis Polígonos MX',
			'pharolgo-drivers': 'Mis Despachadores MX',
		},
		antd: {
			'antd-main': 'Mis Componentes MX',
			'antd-input': 'Input MX',
			'antd-button': 'Button MX',
			'antd-select': 'Select MX',
			'antd-alert': 'Alert MX',
			'antd-badge': 'Badge MX',
			'antd-table': 'Tabla MX',
			'antd-tabs': 'Tabs MX',
			'antd-text-area': 'Text Area MX',
			'antd-collapse': 'Collapse MX',
			'antd-checkbox': 'Checkbox MX',
			'antd-dropdown': 'Dropdown MX',
			'antd-input-number': 'Input Number MX',
			'antd-modal': 'Modal MX',
			'antd-radio': 'Radio MX',
			'antd-radio-group': 'Radio group MX',
			'antd-switch': 'Switch/Interruptor MX',
			'antd-textarea': 'Textarea MX',
			'antd-breadcrumbs': 'Breadcrumbs MX',
			'antd-search': 'Search MX',
		},
		pharmacyLocals: {
			'pharmacy-locals-main': 'Farmacias MX',
		},
		notifications: {
			'notification-main': 'Notificaciones MX',
		},
		migration: {
			'migration-main': 'Migración MX',
		},
		reserve: {
			'reserve-main': 'Reservas MX',
		},
		recipeHistory: {
			'recipe-history-main': 'Historial de recetas MX',
		},
		modalDirections: {
			'modal-directions-main': 'Modal de direcciones MX',
		},
		exampleAxios: {
			'example-axios-main': 'Ejemplo(Axios) MX',
		},
		search: {
			'search-main': 'Autocomplete MX',
		},
	},
	AR: {
		order: {
			'order-main': 'Ordenes AR',
			'order-pending': 'Pendiente AR',
			'order-aproved': 'Aprobadas AR',
		},
		tracking: {
			'tracking-main': 'Tracking AR',
			'tracking-general': 'General AR',
			'tracking-individual': 'Mi Farmacia AR',
		},
		pharolgo: {
			'pharolgo-main': 'Pharol GO AR',
			'pharolgo-polygons': 'Mis Polígonos AR',
			'pharolgo-drivers': 'Mis Despachadores AR',
		},
		antd: {
			'antd-main': 'Mis Componentes AR',
			'antd-input': 'Input AR',
			'antd-button': 'Button AR',
			'antd-select': 'Select AR',
			'antd-collapse': 'Collapse AR',
			'antd-checkbox': 'Checkbox AR',
			'antd-dropdown': 'Dropdown AR',
			'antd-input-number': 'Input Number AR',
			'antd-modal': 'Modal AR',
			'antd-radio': 'Radio AR',
			'antd-radio-group': 'Radio group AR',
			'antd-switch': 'Switch/Interruptor AR',
			'antd-textarea': 'Textarea AR',
			'antd-breadcrumbs': 'Breadcrumbs AR',
			'antd-search': 'Search AR',
		},
		pharmacyLocals: {
			'pharmacy-locals-main': 'Farmacias CL',
		},
		notifications: {
			'notification-main': 'Notificaciones AR',
		},
		migration: {
			'migration-main': 'Migración AR',
		},
		reserve: {
			'reserve-main': 'Reservas AR',
		},
		recipeHistory: {
			'recipe-history-main': 'Historial de recetas AR',
		},
		modalDirections: {
			'modal-directions-main': 'Modal de direcciones AR',
		},
		exampleAxios: {
			'example-axios-main': 'Ejemplo(Axios) AR',
		},
		search: {
			'search-main': 'Autocomplete AR',
		},
	},
};
export const v2_pages_admin_carousel_carousel_constants_select_options_constant__selectOptions = {
	CL: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLNARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLANICX: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLGREEN: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLZUPHARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Zupharma',
			value: 'zupharma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	MX: [{ label: 'Marketplace Benestarx', value: 'pharol' }],
};
export const v2_pages_admin_carousel_carousel_constants_select_options_marketplace_constant__selectOptionsMarket = {
	CL: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLNARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLANICX: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLGREEN: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLZUPHARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	MX: [
		{
			label: 'Farmafe - Karina I',
			value: 'farmafe',
		},
		{
			label: 'Córner Purex Pino Suaréz',
			value: 'purex1',
		},
		{
			label: 'Córner Purex',
			value: 'purex',
		},
		{
			label: 'Córner Farmafe - Karina I',
			value: 'farmafe',
		},
		{
			label: 'Córner Farmacias Paris',
			value: 'paris',
		},
		{ label: 'Córner Los Angeles', value: 'losangeles' },
		{ label: 'Córner Chispita', value: 'chispita' },

		{
			label: 'Principal',
			value: 'pharol',
		},
	],
};
export const v2_pages_admin_carousel_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },

};
export const v2_pages_admin_landing_constants_select_options_constant__selectOptions = {
	CL: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLNARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLANICX: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLGREEN: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLZUPHARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Zupharma',
			value: 'zupharma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	MX: [{ label: 'Marketplace Benestarx', value: 'pharol' }],
};
export const v2_pages_admin_letters_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },


};
export const v2_pages_admin_letters_constants_select_options_constant__selectOptions = {
	CL: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLNARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLANICX: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLGREEN: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLZUPHARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	MX: [{ label: 'Marketplace Benestarx', value: 'pharol' }],
};
export const v2_pages_admin_letters_constants_select_options_marketplace_constant__selectOptionsMarket = {
	CL: [
		{
			label: 'La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Farmacias Sana Sana', value: 'sanasana' },
		{ label: 'Farmacias Narma', value: 'narma' },

	],
	CLNARMA: [
		{
			label: 'La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Farmacias Sana Sana', value: 'sanasana' },
		{ label: 'Farmacias Narma', value: 'narma' },

	],
	CLANICX: [
		{
			label: 'La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Farmacias Sana Sana', value: 'sanasana' },
		{ label: 'Farmacias Narma', value: 'narma' },

	],
	CLGREEN: [
		{
			label: 'La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Farmacias Sana Sana', value: 'sanasana' },
		{ label: 'Farmacias Narma', value: 'narma' },

	],
	CLZUPHARMA: [
		{
			label: 'La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Farmacias Sana Sana', value: 'sanasana' },
		{ label: 'Farmacias Zupharma', value: 'zupharma' },

	],
	MX: [
		{
			label: 'Córner Purex',
			value: 'purex',
		},
		{
			label: 'Córner Purex Pino Suaréz',
			value: 'purex1',
		},
		{
			label: 'Córner Farmacias Paris',
			value: 'paris',
		},
		{ label: 'Córner Los Angeles', value: 'losangeles' },
		{ label: 'Córner Chispita', value: 'chispita' },

		{
			label: 'Principal',
			value: 'pharol',
		},
	],
};
export const v2_pages_admin_migration_constants_dictionary_constant__dictionary = {
	AR: {
		pharmacy: 'pharmacy',
		marketplace: 'marketplace',
		pharol: 'pharol',
	},
	CL: { pharmacy: 'pharmacy', marketplace: 'marketplace', pharol: 'pharol' },
	CLNARMA: { pharmacy: 'pharmacy', marketplace: 'marketplace', pharol: 'pharol' },
	CLANICX: { pharmacy: 'pharmacy', marketplace: 'marketplace', pharol: 'pharol' },
	CLGREEN: { pharmacy: 'pharmacy', marketplace: 'marketplace', pharol: 'pharol' },
	CLZUPHARMA: { pharmacy: 'pharmacy', marketplace: 'marketplace', pharol: 'pharol' },

	MX: { pharmacy: 'pharmacy', marketplace: 'marketplace', pharol: 'pharol' },

};
export const v2_pages_admin_migration_constants_messages_constant__messages = {
	AR: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'
	},
	CL: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	CLNARMA: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	CLANICX: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	CLGREEN: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	CLZUPHARMA: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	MX: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
};
export const v2_pages_admin_migration_constants_options_marketplace_constant__optionsMarketPlace = {
	CL: [
		{ label: 'Marketplace - Base maestra de productos', value: 'base' },
		{ label: 'Marketplace - Base código de barras', value: 'barcode' },
		{ label: 'Marketplace - Base temporal maestra de productos', value: 'base_temp' },
		{ label: 'Marketplace - Aliado de convenios', value: 'pbm' },
		{ label: 'Marketplace - Ranking de categorías', value: 'rankCategory' },
	],
	CLNARMA: [
		{ label: 'Marketplace - Base maestra de productos', value: 'base' },
		{ label: 'Marketplace - Base código de barras', value: 'barcode' },
		{ label: 'Marketplace - Base temporal maestra de productos', value: 'base_temp' },
		{ label: 'Marketplace - Aliado de convenios', value: 'pbm' },
		{ label: 'Marketplace - Ranking de categorías', value: 'rankCategory' },
	],
	CLANICX: [
		{ label: 'Marketplace - Base maestra de productos', value: 'base' },
		{ label: 'Marketplace - Base código de barras', value: 'barcode' },
		{ label: 'Marketplace - Base temporal maestra de productos', value: 'base_temp' },
		{ label: 'Marketplace - Aliado de convenios', value: 'pbm' },
		{ label: 'Marketplace - Ranking de categorías', value: 'rankCategory' },
	],
	CLGREEN: [
		{ label: 'Marketplace - Base maestra de productos', value: 'base' },
		{ label: 'Marketplace - Base código de barras', value: 'barcode' },
		{ label: 'Marketplace - Base temporal maestra de productos', value: 'base_temp' },
		{ label: 'Marketplace - Aliado de convenios', value: 'pbm' },
		{ label: 'Marketplace - Ranking de categorías', value: 'rankCategory' },
	],
	CLZUPHARMA: [
		{ label: 'Marketplace - Base maestra de productos', value: 'base' },
		{ label: 'Marketplace - Base código de barras', value: 'barcode' },
		{ label: 'Marketplace - Base temporal maestra de productos', value: 'base_temp' },
		{ label: 'Marketplace - Aliado de convenios', value: 'pbm' },
		{ label: 'Marketplace - Ranking de categorías', value: 'rankCategory' },
	],
	AR: [
		{ label: 'Marketplace - Base maestra de productos', value: 'base' },
		{ label: 'Marketplace - Base código de barras', value: 'barcode' },
		{ label: 'Marketplace - Base temporal maestra de productos', value: 'base_temp' },
		{ label: 'Marketplace - Aliado de convenios', value: 'pbm' },
		{ label: 'Marketplace - Ranking de categorías', value: 'rankCategory' },
	],
	MX: [
		{ label: 'Marketplace - Base maestra de productos', value: 'base' },
		{ label: 'Marketplace - Base código de barras', value: 'barcode' },
		{ label: 'Marketplace - Base temporal maestra de productos', value: 'base_temp' },
		{ label: 'Marketplace - Aliado de convenios', value: 'pbm' },
		{ label: 'Marketplace - Ranking de categorías', value: 'rankCategory' },
	],
};
export const v2_pages_admin_migration_constants_options_pharmacy_constant__optionsPharmacy = {
	CL: [
		{ label: 'Farmacia - Stock de productos', value: 'stock' },
		{ label: 'Farmacia - Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Farmacia - Homologación de productos', value: 'match' },
		{ label: 'Farmacia - Precio de productos', value: 'price' },
	],
	CLNARMA: [
		{ label: 'Farmacia - Stock de productos', value: 'stock' },
		{ label: 'Farmacia - Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Farmacia - Homologación de productos', value: 'match' },
		{ label: 'Farmacia - Precio de productos', value: 'price' },
	],
	CLANICX: [
		{ label: 'Farmacia - Stock de productos', value: 'stock' },
		{ label: 'Farmacia - Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Farmacia - Homologación de productos', value: 'match' },
		{ label: 'Farmacia - Precio de productos', value: 'price' },
	],
	CLGREEN: [
		{ label: 'Farmacia - Stock de productos', value: 'stock' },
		{ label: 'Farmacia - Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Farmacia - Homologación de productos', value: 'match' },
		{ label: 'Farmacia - Precio de productos', value: 'price' },
	],
	CLZUPHARMA: [
		{ label: 'Farmacia - Stock de productos', value: 'stock' },
		{ label: 'Farmacia - Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Farmacia - Homologación de productos', value: 'match' },
		{ label: 'Farmacia - Precio de productos', value: 'price' },
	],
	AR: [
		{ label: 'Farmacia - Stock de productos', value: 'stock' },
		{ label: 'Farmacia - Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Farmacia - Homologación de productos', value: 'match' },
		{ label: 'Farmacia - Precio de productos', value: 'price' },
	],
	MX: [
		{ label: 'Farmacia - Stock de productos', value: 'stock' },
		{ label: 'Farmacia - Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Farmacia - Homologación de productos', value: 'match' },
		{ label: 'Farmacia - Precio de productos', value: 'price' },
	],
};
export const v2_pages_admin_migration_constants_states_constant__states = {
	AR: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CL: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CLNARMA: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CLANICX: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CLGREEN: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CLZUPHARMA: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	MX: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
};
export const v2_pages_admin_pharmacy_icons_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },

};
export const v2_pages_admin_pharmacy_icons_constants_select_options_constant__selectOptions = {
	CL: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLNARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLANICX: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLGREEN: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLZUPHARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Zupharma',
			value: 'zupharma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	MX: [{ label: 'Marketplace Benestarx', value: 'pharol' }],
};
export const v2_pages_admin_pharmacy_icons_constants_select_options_marketplace__selectOptionsMarket = {
	CL: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLNARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLANICX: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLGREEN: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLZUPHARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	MX: [
		{
			label: 'Córner Purex ´Pino Suarez',
			value: 'purex',
		},
		{
			label: 'Farmafe - Karina I',
			value: 'farmafe',
		},
		{
			label: 'Córner Purex Pino Suaréz',
			value: 'purex1',
		},
		{
			label: 'Córner Farmacias Paris',
			value: 'paris',
		},
		{ label: 'Córner Los Angeles', value: 'losangeles' },
		{ label: 'Córner Chispita', value: 'chispita' },

		{
			label: 'Principal',
			value: 'pharol',
		},
	],
};
export const v2_pages_admin_pharmacy_locals_list_components_ListView_constants_column_titles_constant__columnTitles = {
	CL: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	CLNARMA: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	CLANICX: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	CLGREEN: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	CLZUPHARMA: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	MX: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},

	AR: {
    brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
};
export const v2_pages_admin_pharmacy_sliders_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },

};
export const v2_pages_admin_pharmacy_sliders_constants_select_options_constant__selectOptions = {
	CL: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLNARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLANICX: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLGREEN: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLZUPHARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Zupharma',
			value: 'zupharma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	MX: [{ label: 'Marketplace Benestarx', value: 'pharol' }],
};
export const v2_pages_admin_pharmacy_sliders_constants_select_options_marketplace__selectOptionsMarket = {
	CL: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLNARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLANICX: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLGREEN: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLZUPHARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	MX: [
		{
			label: 'Córner Purex Pino Suarez',
			value: 'purex',
		},
		{
			label: 'Córner Purex Pino Suaréz',
			value: 'purex1',
		},
		{
			label: 'Farmafe - Karina I',
			value: 'farmafe',
		},
		{
			label: 'Córner Farmacias Paris',
			value: 'paris',
		},
		{ label: 'Córner Los Angeles', value: 'losangeles' },
		{ label: 'Córner Chispita', value: 'chispita' },

		{
			label: 'Principal',
			value: 'pharol',
		},
	],
};
export const v2_pages_admin_qf_criterion_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },

};
export const v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_approve_button_constant__approveButton = {
	AR: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CL: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CLNARMA: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CLANICX: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CLGREEN: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CLZUPHARMA: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	MX: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},

};
export const v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_cancel_button_constant__cancelButton = {
	AR: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CL: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CLNARMA: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CLANICX: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CLGREEN: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CLZUPHARMA: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	MX: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},

};
export const v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_confirm_button_constant__confirmButton = {
	AR: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CL: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CLNARMA: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CLANICX: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CLGREEN: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CLZUPHARMA: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	MX: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},

};
export const v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_data_steps_constant__dataSteps = {
	AR: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de armado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido cancelado',
		},
		{
			status: 9,
			title: 'Entrega confirmada',
		},
	],
	CL: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLNARMA: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLANICX: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLGREEN: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLZUPHARMA: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	MX: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
};
export const v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus = {
	AR: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CL: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CLNARMA: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CLANICX: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CLGREEN: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CLZUPHARMA: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	MX: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
};
export const v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_payment_method_constants__paymentMethod = {
    CL:{
        MP:"mercadopago-cl"
    },
    CLNARMA:{
        MP:"mercadopago-cl"
    },
	CLANICX: {
        MP:"mercadopago-cl"
    },
	CLGREEN: {
        MP:"mercadopago-cl"
    },
	CLZUPHARMA: {
        MP:"mercadopago-cl"
    },
    MX:{
        MP:"mercadopago-mx"
    }
};
export const v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_status_names_constant__statusNames = {
	AR: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CL: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CLNARMA: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CLANICX: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CLGREEN: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CLZUPHARMA: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	MX: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
};
export const v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_type_retirement_constant__typeRetirement = {
	AR: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CL: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLNARMA: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLANICX: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLGREEN: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLZUPHARMA: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	MX: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
};
export const v2_pages_admin_quotation_quotation_detail_components_TrackingProgress_constants_status_constant__status = {
	AR: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},


	],
	CL: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	CLNARMA: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	CLANICX: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	CLGREEN: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	CLZUPHARMA: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	MX: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
};
export const v2_pages_admin_quotation_quotation_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement = {
	AR: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Envío a Domicilio',
	},
	CL: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLNARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLANICX: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLGREEN: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLZUPHARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
};
export const v2_pages_admin_quotation_quotation_detail_constants_delete_products_status_constant__deleteProductStatus = {
	AR: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CL: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CLNARMA: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CLANICX: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CLGREEN: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CLZUPHARMA: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	MX: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
};
export const v2_pages_admin_quotation_quotation_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns = {
	AR: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'CUIL',
		rut: 'DNI',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'
	},
	CL: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLNARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLANICX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLGREEN: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLZUPHARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	MX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'CURP',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Estado',
		commune: 'Municipio',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
};
export const v2_pages_admin_quotation_quotation_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn = {
	AR: {
		name: 'Nombre',
		lastname: 'Apellido',
		document: 'Dni',
		email: 'Email',
		gender: 'Género',
		status: 'Status',
		phone:'Teléfono'
	},
	CL: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	MX: { name: 'Nombre', lastname: 'Apellido', document: 'Curp', email: 'Email', gender: 'Género', status: 'Status',phone:'Teléfono' },
	CLNARMA: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLANICX: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLGREEN: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLZUPHARMA: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },

};
export const v2_pages_admin_quotation_quotation_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn = {
	AR: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CL: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLNARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLANICX: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLGREEN: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLZUPHARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	MX: {
		region: 'Estado',
		commune: 'Colonia',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
		municipality: 'Municipio',
	},
};
export const v2_pages_admin_quotation_quotation_detail_constants_dictionary_information_constant__dictionaryInformation = {
	AR: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'
	},
	CL: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLNARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLANICX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLGREEN: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLZUPHARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	MX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
};
export const v2_pages_admin_quotation_quotation_detail_constants_dictionary_order_detail_columns_constant__dictionaryOrderDetailColumn = {
	AR: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CL: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CLNARMA: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CLANICX: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CLGREEN: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CLZUPHARMA: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	MX: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
};
export const v2_pages_admin_quotation_quotation_detail_constants_dictionary_payment_columns_contant__dictionaryPaymentColumn = {
	AR: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CL: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLNARMA: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLANICX: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLGREEN: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLZUPHARMA: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	MX: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
};
export const v2_pages_admin_quotation_quotation_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn = {
	AR: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento u.',
		total: 'Precio final u.',
		recipe: 'Receta',
		actions:'Acciones'
	},
	CL: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	MX: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta',actions:'Acciones' },
	CLNARMA: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLANICX: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLGREEN: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLZUPHARMA: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },

};
export const v2_pages_admin_quotation_quotation_detail_constants_only_recipe_constant__onlyRecipe = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
	},
	CL: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_admin_quotation_quotation_detail_constants_product_constant__Product = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
		NP: 'NP', // Venta Libre
		PM: 'PM', // Producto Masivo
		mecanicDiscountOff: 'X % Descuento',
		mecanicNxM: 'N x M',
	},
	CL: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_admin_quotation_quotation_detail_constants_status_adapter_constant__statusAdapter = {
	AR: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CL: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLNARMA: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLANICX: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLGREEN: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLZUPHARMA: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	MX: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
};
export const v2_pages_admin_quotation_quotation_list_constants_column_titles_constant__ColumnTitles = {
	CL: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	CLNARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	CLANICX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	CLGREEN: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	CLZUPHARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	MX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha y hora',
    detailOrder:'Detalle'
	},

	AR: {
		trx_id: 'N° de orden',
		operation_id: 'N° de reserva',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha y hora',
    detailOrder:'Detalle'
	},
};
export const v2_pages_admin_quotation_quotation_list_constants_dictionary_constant__Dictionary = {
	CL: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLNARMA: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLANICX: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLGREEN: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLZUPHARMA: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	MX: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	AR: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Partido',
		Commune: 'Localidad',
		RUT: 'DNI',
	},
};
export const v2_pages_admin_quotation_quotation_list_constants_status_constant__statusPreparation = {
	AR: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CL: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLNARMA: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLANICX: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLGREEN: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLZUPHARMA: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	MX: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
};
export const v2_pages_admin_quotation_quotation_list_constants_status_description_constant__statusDescription = {
	AR: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CL: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLNARMA: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLANICX: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLGREEN: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLZUPHARMA: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	MX: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
};
export const v2_pages_admin_quotation_quotation_list_constants_type_delivery_constant__typeDelivery = {
	AR: {
		all:'Todas',
		pharmacy: 'Retiro en farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CL: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLNARMA: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLANICX: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLGREEN: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLZUPHARMA: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	MX: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
};
export const v2_pages_admin_report_components_ProductReport_constants_language_constant__Language = {
	CL: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	CLNARMA: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	CLANICX: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	CLGREEN: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	CLZUPHARMA: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	MX: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	AR: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
};
export const v2_pages_admin_report_constants_language_constant__Language = {
	CL: {
		title: 'Reporte de Productos',
	},
	CLNARMA: {
		title: 'Reporte de Productos',
	},
	CLANICX: {
		title: 'Reporte de Productos',
	},
	CLGREEN: {
		title: 'Reporte de Productos',
	},
	CLZUPHARMA: {
		title: 'Reporte de Productos',
	},
	MX: {
		title: 'Reporte de Productos',
	},
	AR: {
		title: 'Reporte de Productos (AR)',
	},
};
export const v2_pages_admin_reserve_reserve_list_constants_column_titles_constant__ColumnTitles = {
	CL: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	CLNARMA: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	CLANICX: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	CLGREEN: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	CLZUPHARMA: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	MX: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	AR: {
		operation_id: 'N° de reserva',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
};
export const v2_pages_admin_reserve_reserve_list_constants_status_names_constant__statusNames = {
	AR: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CL: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CLNARMA: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CLANICX: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CLGREEN: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CLZUPHARMA: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	MX: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
};
export const v2_pages_admin_stock_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },

};
export const v2_pages_admin_tracking_orders_list_constants_column_titles_constant__ColumnTitles = {
	CL: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	CLNARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	CLANICX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	CLGREEN: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	CLZUPHARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	MX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},

	AR: {
		trx_id: 'N° de orden',
		operation_id: 'N° de reserva',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
};
export const v2_pages_admin_tracking_orders_list_constants_dictionary_constant__Dictionary = {
	CL: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLNARMA: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLANICX: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLGREEN: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLZUPHARMA: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	MX: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Estado',
		commune: 'Asentamiento',
		Rut: 'CURP',
	},

	AR: {
		pending: 'Pendiente',
		to_deliver: 'Por entregar',
		delivered: 'Entregada',
		rejected: 'Rechazado',
		region: 'Partido',
		Commune: 'Localidad',
		RUT: 'DNI',
	},
};
export const v2_pages_admin_tracking_orders_list_constants_status_constant__statusPreparation = {
	AR: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de armado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CL: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CLNARMA: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CLANICX: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CLGREEN: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CLZUPHARMA: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	MX: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
};
export const v2_pages_admin_tracking_orders_list_constants_status_description_constant__statusDescription = {
	AR: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CL: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CLNARMA: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CLANICX: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CLGREEN: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CLZUPHARMA: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	MX: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
};
export const v2_pages_admin_tracking_orders_list_constants_type_delivery_constant__typeDelivery = {
	AR: {
		all:'Todas',
		pharmacy: 'Retiro en farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CL: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLNARMA: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLANICX: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLGREEN: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLZUPHARMA: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	MX: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
};
export const v2_pages_carousel_carousel_constants_select_options_constant__selectOptions = {
	CL: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLNARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLANICX: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLGREEN: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLZUPHARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	MX: [{ label: 'Marketplace Benestarx', value: 'pharol' }],
};
export const v2_pages_carousel_carousel_constants_select_options_marketplace_constant__selectOptionsMarket = {
	CL: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLNARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLANICX: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLGREEN: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLZUPHARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	MX: [
		{
			label: 'Córner Purex',
			value: 'purex',
		},
		{
			label: 'Córner Purex Pino Suaréz',
			value: 'purex1',
		},
		{
			label: 'Córner Farmacias Paris',
			value: 'paris',
		},
		{ label: 'Córner Los Angeles', value: 'losangeles' },
		{ label: 'Córner Chispita', value: 'chispita' },

		{
			label: 'Principal',
			value: 'pharol',
		},
	],
};
export const v2_pages_carousel_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },

};
export const v2_pages_landing_constants_select_options_constant__selectOptions = {
	CL: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLNARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLANICX: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLGREEN: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLZUPHARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Zupharma',
			value: 'zupharma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	MX: [{ label: 'Marketplace Benestarx', value: 'pharol' }],
};
export const v2_pages_letters_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },

};
export const v2_pages_migration_constants_messages_constant__messages = {
	AR: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'
	},
	CL: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	CLNARMA: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	CLANICX: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	CLGREEN: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	CLZUPHARMA: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
	MX: {
		success: 'Se ha adjuntado y cargado correctamente.',
		error: 'No se ha adjuntado correctamente, vuelva a intentarlo teniendo en cuenta las especificaciones.',
    invalid: 'Tipo de archivo inválido, vuelva a adjuntarlo teniendo en cuenta las especificaciones.',
    server:'Internal Server Error'

	},
};
export const v2_pages_migration_constants_options_constant__Options = {
	CL: [
		{ label: 'Stock de productos', value: 'stock' },
		{ label: 'Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Homologación de productos', value: 'match' },
		{ label: 'Precio de productos', value: 'price' },
	],
	CLNARMA: [
		{ label: 'Stock de productos', value: 'stock' },
		{ label: 'Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Homologación de productos', value: 'match' },
		{ label: 'Precio de productos', value: 'price' },
	],
	CLANICX: [
		{ label: 'Stock de productos', value: 'stock' },
		{ label: 'Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Homologación de productos', value: 'match' },
		{ label: 'Precio de productos', value: 'price' },
	],
	CLGREEN: [
		{ label: 'Stock de productos', value: 'stock' },
		{ label: 'Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Homologación de productos', value: 'match' },
		{ label: 'Precio de productos', value: 'price' },
	],
	CLZUPHARMA: [
		{ label: 'Stock de productos', value: 'stock' },
		{ label: 'Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Homologación de productos', value: 'match' },
		{ label: 'Precio de productos', value: 'price' },
	],
	MX: [
		{ label: 'Stock de productos', value: 'stock' },
		{ label: 'Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Homologación de productos', value: 'match' },
		{ label: 'Precio de productos', value: 'price' },
	],
	AR: [
		{ label: 'Stock de productos', value: 'stock' },
		{ label: 'Promociones aplicadas a producto', value: 'promotion' },
		{ label: 'Homologación de productos', value: 'match' },
		{ label: 'Precio de productos', value: 'price' },
	],
};
export const v2_pages_migration_constants_states_constant__states = {
	AR: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CL: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CLNARMA: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CLANICX: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CLGREEN: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	CLZUPHARMA: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
	MX: {
		uploading: 'uploading',
		done: 'done',
		error: 'error',
	},
};
export const v2_pages_notification_notifications_list_constants_select_options_constant__selectOptions = {
	MX: [
		{ label: 'Todo', value: null },
		{ label: 'Órdenes', value: 'new-order' },
		{ label: 'Reclamos y sugerencias', value: 'new-claim' },
		{ label: 'Cotizaciones', value: 'new-quotation' },
		{ label: 'Pre-órdenes', value: 'new-preorder' },
		{ label: 'Recetas', value: 'new-recipe' },

		// {
		// 	label: 'Purex',
		// 	value: 'purex',
		// },
		// {
		// 	label: 'Paris',
		// 	value: 'paris',
		// },
		// { label: 'Los Angeles', value: 'losangeles' },
		// { label: 'ABC', value: 'abc' },
		// { label: 'Farmazul', value: 'farmazul' },
		// { label: 'Farmacias Prueba', value: 'pruebamx' },

		// {
		// 	label: 'Principal',
		// 	value: 'pharol',
		// },
	],
	CL: [
		{ label: 'Todo', value: null },
		{ label: 'Órdenes', value: 'new-order' },
		{ label: 'Reclamos y sugerencias', value: 'new-claim' },
		{ label: 'Cotizaciones', value: 'new-quotation' },
		{ label: 'Pre-órdenes', value: 'new-preorder' },
		{ label: 'Recetas', value: 'new-recipe' },
	],
	CLNARMA: [
		{ label: 'Todo', value: null },
		{ label: 'Órdenes', value: 'new-order' },
		{ label: 'Reclamos y sugerencias', value: 'new-claim' },
		{ label: 'Cotizaciones', value: 'new-quotation' },
		{ label: 'Pre-órdenes', value: 'new-preorder' },
		{ label: 'Recetas', value: 'new-recipe' },
	],
	CLANICX: [
		{ label: 'Todo', value: null },
		{ label: 'Órdenes', value: 'new-order' },
		{ label: 'Reclamos y sugerencias', value: 'new-claim' },
		{ label: 'Cotizaciones', value: 'new-quotation' },
		{ label: 'Pre-órdenes', value: 'new-preorder' },
		{ label: 'Recetas', value: 'new-recipe' },
	],
	CLGREEN: [
		{ label: 'Todo', value: null },
		{ label: 'Órdenes', value: 'new-order' },
		{ label: 'Reclamos y sugerencias', value: 'new-claim' },
		{ label: 'Cotizaciones', value: 'new-quotation' },
		{ label: 'Pre-órdenes', value: 'new-preorder' },
		{ label: 'Recetas', value: 'new-recipe' },
	],
	CLZUPHARMA: [
		{ label: 'Todo', value: null },
		{ label: 'Órdenes', value: 'new-order' },
		{ label: 'Reclamos y sugerencias', value: 'new-claim' },
		{ label: 'Cotizaciones', value: 'new-quotation' },
		{ label: 'Pre-órdenes', value: 'new-preorder' },
		{ label: 'Recetas', value: 'new-recipe' },
	],
};
export const v2_pages_pharmacy_icons_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },

};
export const v2_pages_pharmacy_icons_constants_select_options_constant__selectOptions = {
	CL: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLNARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLANICX: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLGREEN: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Narma',
			value: 'narma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	CLZUPHARMA: [
		{
			label: 'E-commerce Anich',
			value: 'anich',
		},
		{
			label: 'E-commerce JVF',
			value: 'jvf',
		},
		{
			label: 'E-commerce Sana Sana',
			value: 'sanasana',
		},
		{
			label: 'E-commerce Zupharma',
			value: 'zupharma',
		},
		{ label: 'Marketplace Tirxs', value: 'pharol' },
	],
	MX: [{ label: 'Marketplace Benestarx', value: 'pharol' }],
};
export const v2_pages_pharmacy_icons_constants_select_options_marketplace__selectOptionsMarket = {
	CL: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLNARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLANICX: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLGREEN: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	CLZUPHARMA: [
		{
			label: 'Córner La Botica Anich',
			value: 'anich',
		},
		{
			label: 'Córner Farmacias JVF',
			value: 'jvf',
		},
		{ label: 'Córner Farmacias Sana Sana', value: 'sanasana' },
		{
			label: 'Principal',
			value: 'pharol',
		},
	],
	MX: [
		{
			label: 'Córner Purex',
			value: 'purex',
		},
		{
			label: 'Córner Purex Pino Suaréz',
			value: 'purex1',
		},
		{
			label: 'Córner Farmacias Paris',
			value: 'paris',
		},
		{ label: 'Córner Los Angeles', value: 'losangeles' },
		{ label: 'Córner Chispita', value: 'chispita' },

		{
			label: 'Principal',
			value: 'pharol',
		},
	],
};
export const v2_pages_pharmacy_locals_list_components_ListView_constants_column_titles_constant__columnTitles = {
	CL: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	CLNARMA: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	CLANICX: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	CLGREEN: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	CLZUPHARMA: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
	MX: {
		brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},

	AR: {
    brand: 'Marca',
		code_local: 'Identificador',
		name_local: 'Nombre visible en web',
		direction: 'Dirección',
		detail: 'Ver detalle',
	},
};
export const v2_pages_pharmacy_sliders_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },

};
export const v2_pages_preorder_preorder_detail_components_StatusCard_constants_approve_button_constant__approveButton = {
	AR: {
		100: 'Aprobar',
	},
	CL: {
		100: 'Aprobar',
	},
	CLNARMA: {
		100: 'Aprobar',
	},
	CLANICX: {
		100: 'Aprobar',
	},
	CLGREEN: {
		100: 'Aprobar',
	},
	CLZUPHARMA: {
		100: 'Aprobar',
	},
	MX: {
		100: 'Aprobar',
	},

};
export const v2_pages_preorder_preorder_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus = {
	AR: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CL: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CLNARMA: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CLANICX: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CLGREEN: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CLZUPHARMA: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	MX: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
};
export const v2_pages_preorder_preorder_detail_components_StatusCard_constants_link_order_button_constant__linkOrderButton = {
	AR: {
    600: 'Ver orden',
	},
  CL: {
    600: 'Ver orden',
    },
    CLNARMA: {
        600: 'Ver orden',
        },
	CLANICX: {
        600: 'Ver orden',
        },
	CLGREEN: {
        600: 'Ver orden',
        },
	CLZUPHARMA: {
        600: 'Ver orden',
        },
	MX: {
    600: 'Ver orden',
	},

};
export const v2_pages_preorder_preorder_detail_components_StatusCard_constants_status_names_constant__statusNames = {
	AR: {
		100: 'Pre-orden por aprobar',
		600: 'Pre-orden pagada'
	},
	CL: {
		100: 'Pre-orden por aprobar',
		600: 'Pre-orden pagada'

	},
	CLNARMA: {
		100: 'Pre-orden por aprobar',
		600: 'Pre-orden pagada'

	},
	CLANICX: {
		100: 'Pre-orden por aprobar',
		600: 'Pre-orden pagada'

	},
	CLGREEN: {
		100: 'Pre-orden por aprobar',
		600: 'Pre-orden pagada'

	},
	CLZUPHARMA: {
		100: 'Pre-orden por aprobar',
		600: 'Pre-orden pagada'

	},
	MX: {
		100: 'Pre-orden por aprobar',
		600: 'Pre-orden pagada'
	},
};
export const v2_pages_preorder_preorder_detail_components_TrackingProgress_constants_status_constant__status = {
	AR: [
		{
			status: 100,
			description: 'Pre-orden por aprobar',
		},

		{
			status: 600,
			description: 'Pre-orden pagada',
		},


	],
	CL: [
		{
			status: 100,
			description: 'Pre-orden por aprobar',
		},
		{
			status: 600,
			description: 'Pre-orden pagada',
		},
	],
	CLNARMA: [
		{
			status: 100,
			description: 'Pre-orden por aprobar',
		},
		{
			status: 600,
			description: 'Pre-orden pagada',
		},
	],
	CLANICX: [
		{
			status: 100,
			description: 'Pre-orden por aprobar',
		},
		{
			status: 600,
			description: 'Pre-orden pagada',
		},
	],
	CLGREEN: [
		{
			status: 100,
			description: 'Pre-orden por aprobar',
		},
		{
			status: 600,
			description: 'Pre-orden pagada',
		},
	],
	CLZUPHARMA: [
		{
			status: 100,
			description: 'Pre-orden por aprobar',
		},
		{
			status: 600,
			description: 'Pre-orden pagada',
		},
	],
	MX: [
		{
			status: 100,
			description: 'Pre-orden por aprobar',
		},
		{
			status: 600,
			description: 'Pre-orden pagada',
		},
	],
};
export const v2_pages_preorder_preorder_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement = {
	AR: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Envío a Domicilio',
	},
	CL: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLNARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLANICX: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLGREEN: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLZUPHARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
};
export const v2_pages_preorder_preorder_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns = {
	AR: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'CUIL',
		rut: 'DNI',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'
	},
	CL: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLNARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLANICX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLGREEN: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLZUPHARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	MX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'CURP',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Estado',
		commune: 'Municipio',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
};
export const v2_pages_preorder_preorder_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn = {
	AR: {
		name: 'Nombre y Apellido',
		document: 'Dni',
		email: 'Email',
		gender: 'Género',
		status: 'Status',
		phone:'Teléfono'
	},
	CL: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	MX: {	name: 'Nombre y Apellido', lastname: 'Apellido', document: 'Curp', email: 'Email', gender: 'Género', status: 'Status',phone:'Teléfono' },
	CLNARMA: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLANICX: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLGREEN: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLZUPHARMA: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },

};
export const v2_pages_preorder_preorder_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn = {
	AR: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CL: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLNARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLANICX: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLGREEN: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLZUPHARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	MX: {
		region: 'Estado',
		commune: 'Colonia',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
		municipality: 'Municipio',
	},
};
export const v2_pages_preorder_preorder_detail_constants_dictionary_information_constant__dictionaryInformation = {
	AR: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		delivery: 'Información de entrega',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'
	},
	CL: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		delivery: 'Información de entrega',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLNARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		delivery: 'Información de entrega',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLANICX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		delivery: 'Información de entrega',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLGREEN: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		delivery: 'Información de entrega',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLZUPHARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		delivery: 'Información de entrega',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	MX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		delivery: 'Información de entrega',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
};
export const v2_pages_preorder_preorder_detail_constants_dictionary_order_columns_constant__dictionaryOrderColumn = {
	AR: {
		tracking_id: 'ID Tracking',
		preorder_id: 'N° de Pre-orden',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
		request_number: 'N° Solicitud',
		order_date: 'Fecha de pedido',
		estimated_delivery_date: 'Fecha estimada de entrega',
	},
	CL: {
		tracking_id: 'ID Tracking',
		preorder_id: 'N° Pre-orden',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
		request_number: 'N° Solicitud',
		order_date: 'Fecha de pedido',
		estimated_delivery_date: 'Fecha estimada de entrega',
	},
	CLNARMA: {
		tracking_id: 'ID Tracking',
		request_number: 'N° Solicitud',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
		preorder_id: 'N° de Pre-orden',
		order_date: 'Fecha de pedido',
		estimated_delivery_date: 'Fecha estimada de entrega',
	},
	CLANICX: {
		tracking_id: 'ID Tracking',
		request_number: 'N° Solicitud',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
		preorder_id: 'N° de Pre-orden',
		order_date: 'Fecha de pedido',
		estimated_delivery_date: 'Fecha estimada de entrega',
	},
	CLGREEN: {
		tracking_id: 'ID Tracking',
		request_number: 'N° Solicitud',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
		preorder_id: 'N° de Pre-orden',
		order_date: 'Fecha de pedido',
		estimated_delivery_date: 'Fecha estimada de entrega',
	},
	CLZUPHARMA: {
		tracking_id: 'ID Tracking',
		request_number: 'N° Solicitud',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
		preorder_id: 'N° de Pre-orden',
		order_date: 'Fecha de pedido',
		estimated_delivery_date: 'Fecha estimada de entrega',
	},
	MX: {
		tracking_id: 'ID Tracking',
		request_number: 'N° Solicitud',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
		preorder_id: 'N° Pre-orden',
		order_date: 'Fecha de pedido',
		estimated_delivery_date: 'Fecha estimada de entrega',
	},
};
export const v2_pages_preorder_preorder_detail_constants_dictionary_payment_columns_constant__dictionaryPaymentColumn = {
	AR: {
		payment_date: 'Fecha de pago',
		products_total: 'Total producto/s',
		shipping_total: 'Total envío',
		general_total: 'Total general',
		payment_method: 'Forma de pago',
	},
	CL: {
		payment_date: 'Fecha de pago',
		products_total: 'Total producto/s',
		shipping_total: 'Total envío',
		general_total: 'Total general',
		payment_method: 'Forma de pago',
	},
	CLNARMA: {
		payment_date: 'Fecha de pago',
		products_total: 'Total producto/s',
		shipping_total: 'Total envío',
		general_total: 'Total general',
		payment_method: 'Forma de pago',
	},
	CLANICX: {
		payment_date: 'Fecha de pago',
		products_total: 'Total producto/s',
		shipping_total: 'Total envío',
		general_total: 'Total general',
		payment_method: 'Forma de pago',
	},
	CLGREEN: {
		payment_date: 'Fecha de pago',
		products_total: 'Total producto/s',
		shipping_total: 'Total envío',
		general_total: 'Total general',
		payment_method: 'Forma de pago',
	},
	CLZUPHARMA: {
		payment_date: 'Fecha de pago',
		products_total: 'Total producto/s',
		shipping_total: 'Total envío',
		general_total: 'Total general',
		payment_method: 'Forma de pago',
	},
	MX: {
		payment_date: 'Fecha de pago',
		products_total: 'Total producto/s',
		shipping_total: 'Total envío',
		general_total: 'Total general',
		payment_method: 'Forma de pago',
	},
};
export const v2_pages_preorder_preorder_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn = {
	AR: {
		expand: 'Ver más',
		name: 'Nombre',
		quantity: 'Cant',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final',
		recipe: 'Receta',
		actions: 'Acciones'
	},
	CL: {
		expand: 'Ver más',
		name: 'Nombre',
		quantity: 'Cant',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final',
		recipe: 'Receta',
		actions: 'Acciones'
	},
	CLNARMA: {
		expand: 'Ver más',
		name: 'Nombre',
		quantity: 'Cant',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final',
		recipe: 'Receta',
		actions: 'Acciones'
	},
	CLANICX: {
		expand: 'Ver más',
		name: 'Nombre',
		quantity: 'Cant',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final',
		recipe: 'Receta',
		actions: 'Acciones'
	},
	CLGREEN: {
		expand: 'Ver más',
		name: 'Nombre',
		quantity: 'Cant',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final',
		recipe: 'Receta',
		actions: 'Acciones'
	},
	CLZUPHARMA: {
		expand: 'Ver más',
		name: 'Nombre',
		quantity: 'Cant',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final',
		recipe: 'Receta',
		actions: 'Acciones'
	},
	MX: {
		expand: 'Ver más',
		name: 'Nombre',
		quantity: 'Cant',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final',
		recipe: 'Receta',
		actions: 'Acciones'
	},
};
export const v2_pages_preorder_preorder_detail_constants_only_recipe_constant__onlyRecipe = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
	},
	CL: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_preorder_preorder_detail_constants_product_constant__Product = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
		NP: 'NP', // Venta Libre
		PM: 'PM', // Producto Masivo
		mecanicDiscountOff: 'X % Descuento',
		mecanicNxM: 'N x M',
	},
	CL: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_preorder_preorder_list_constants_column_titles_constant__ColumnTitles = {
	CL: {
		trx_id: 'N° de orden',
		preorder_id: 'N° pre-orden',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		quotation_short_code: 'N° de cotización',
		status: 'Estado',
		createdAt: 'Fecha',
		detailOrder: 'Detalle',
		rut: 'Rut',
		email: 'Correo electrónico'
	},
	MX: {
		trx_id: 'N° de orden',
		preorder_id: 'N° de pre-orden',
		quotation_short_code: 'N° de cotización',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha y hora',
    	detailOrder:'Detalle'
	},
	CLNARMA: {
		trx_id: 'N° de orden',
		preorder_id: 'N° de pre-orden',
		quotation_short_code: 'N° de cotización',
		pharmacy:'Farmacia',
		rut: 'RUT',
		email: 'Correo electrónico',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha',
    	detailOrder:'Detalle'
	},
	CLANICX: {
		trx_id: 'N° de orden',
		preorder_id: 'N° de pre-orden',
		quotation_short_code: 'N° de cotización',
		pharmacy:'Farmacia',
		rut: 'RUT',
		email: 'Correo electrónico',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha',
    	detailOrder:'Detalle'
	},
	CLGREEN: {
		trx_id: 'N° de orden',
		preorder_id: 'N° de pre-orden',
		quotation_short_code: 'N° de cotización',
		pharmacy:'Farmacia',
		rut: 'RUT',
		email: 'Correo electrónico',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha',
    	detailOrder:'Detalle'
	},
	CLZUPHARMA: {
		trx_id: 'N° de orden',
		preorder_id: 'N° de pre-orden',
		quotation_short_code: 'N° de cotización',
		pharmacy:'Farmacia',
		rut: 'RUT',
		email: 'Correo electrónico',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha',
    	detailOrder:'Detalle'
	},
	AR: {
		trx_id: 'N° de orden',
		preorder_id: 'N° pre-orden',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha y hora',
    detailOrder:'Detalle'
	},
};
export const v2_pages_preorder_preorder_list_constants_dictionary_constant__Dictionary = {
	CL: {
		pending: 'Pendiente',
		paid: 'Pagada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	MX: {
		pending: 'Pendiente',
		paid: 'Pagada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLNARMA: {
		pending: 'Pendiente',
		paid: 'Pagada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLANICX: {
		pending: 'Pendiente',
		paid: 'Pagada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLGREEN: {
		pending: 'Pendiente',
		paid: 'Pagada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLZUPHARMA: {
		pending: 'Pendiente',
		paid: 'Pagada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	AR: {
		pending: 'Pendiente',
		paid: 'Pagada',
		region: 'Partido',
		Commune: 'Localidad',
		RUT: 'DNI',
	},
};
export const v2_pages_preorder_preorder_list_constants_status_constant__statusPreparation = {
	AR: {
		pending: 'pendiente',
		paid: 'pagada',
	},
	CL: {

		pending: 'pendiente',
		paid: 'pagada',
	},
	CLNARMA: {
		pending: 'pendiente',
		paid: 'pagada',
	},
	CLANICX: {
		pending: 'pendiente',
		paid: 'pagada',
	},
	CLGREEN: {
		pending: 'pendiente',
		paid: 'pagada',
	},
	CLZUPHARMA: {
		pending: 'pendiente',
		paid: 'pagada',
	},
	MX: {
		pending: 'pendiente',
		paid: 'pagada',
	},
};
export const v2_pages_qf_criterion_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },

};
export const v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_approve_button_constant__approveButton = {
	AR: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CL: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CLNARMA: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CLANICX: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CLGREEN: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	CLZUPHARMA: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},
	MX: {
		100: 'CONTINUAR',
		200: 'CONTINUAR',
		300: 'CONTINUAR',
		400: 'CONTINUAR',
		500: 'CONTINUAR',
	},

};
export const v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_cancel_button_constant__cancelButton = {
	AR: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CL: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CLNARMA: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CLANICX: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CLGREEN: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	CLZUPHARMA: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},
	MX: {
		100: 'RECHAZAR',
		200: 'RECHAZAR',
		300: 'RECHAZAR',
		400: 'RECHAZAR',
		500: 'RECHAZAR',
	},

};
export const v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_confirm_button_constant__confirmButton = {
	AR: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CL: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CLNARMA: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CLANICX: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CLGREEN: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	CLZUPHARMA: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},
	MX: {
		100: 'Continuar',
		200: 'Continuar',
		300: 'Continuar',
		400: 'Continuar',
		500: 'Continuar',
	},

};
export const v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_data_steps_constant__dataSteps = {
	AR: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de armado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido cancelado',
		},
		{
			status: 9,
			title: 'Entrega confirmada',
		},
	],
	CL: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLNARMA: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLANICX: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLGREEN: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLZUPHARMA: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	MX: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
};
export const v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus = {
	AR: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CL: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CLNARMA: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CLANICX: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CLGREEN: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CLZUPHARMA: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	MX: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_payment_method_constants__paymentMethod = {
    CL:{
        MP:"mercadopago-cl"
    },
    CLNARMA:{
        MP:"mercadopago-cl"
    },
	CLANICX: {
        MP:"mercadopago-cl"
    },
	CLGREEN: {
        MP:"mercadopago-cl"
    },
	CLZUPHARMA: {
        MP:"mercadopago-cl"
    },
    MX:{
        MP:"mercadopago-mx"
    }
};
export const v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_status_names_constant__statusNames = {
	AR: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CL: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CLNARMA: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CLANICX: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CLGREEN: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	CLZUPHARMA: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
	MX: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Cotización rechazada',
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_type_retirement_constant__typeRetirement = {
	AR: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CL: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLNARMA: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLANICX: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLGREEN: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLZUPHARMA: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	MX: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_components_TrackingProgress_constants_status_constant__status = {
	AR: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},


	],
	CL: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	CLNARMA: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	CLANICX: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	CLGREEN: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	CLZUPHARMA: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
	MX: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
	],
};
export const v2_pages_quotation_deprecated_quotation_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement = {
	AR: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Envío a Domicilio',
	},
	CL: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLNARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLANICX: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLGREEN: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLZUPHARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_constants_delete_products_status_constant__deleteProductStatus = {
	AR: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CL: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
		CLNARMA: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
		CLANICX: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
		CLGREEN: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
		CLZUPHARMA: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	MX: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns = {
	AR: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'CUIL',
		rut: 'DNI',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'
	},
	CL: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLNARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLANICX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLGREEN: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLZUPHARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	MX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'CURP',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Estado',
		commune: 'Municipio',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
};
export const v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn = {
	AR: {
		name: 'Nombre',
		lastname: 'Apellido',
		document: 'Dni',
		email: 'Email',
		gender: 'Género',
		status: 'Status',
		phone:'Teléfono'
	},
	CL: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	MX: { name: 'Nombre', lastname: 'Apellido', document: 'Curp', email: 'Email', gender: 'Género', status: 'Status',phone:'Teléfono' },
	CLNARMA: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLANICX: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLGREEN: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLZUPHARMA: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },

};
export const v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn = {
	AR: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CL: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLNARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLANICX: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLGREEN: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLZUPHARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	MX: {
		region: 'Estado',
		commune: 'Colonia',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
		municipality: 'Municipio',
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_information_constant__dictionaryInformation = {
	AR: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'
	},
	CL: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLNARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLANICX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLGREEN: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLZUPHARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	MX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
};
export const v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_order_detail_columns_constant__dictionaryOrderDetailColumn = {
	AR: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CL: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CLNARMA: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CLANICX: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CLGREEN: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	CLZUPHARMA: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
	MX: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_payment_columns_contant__dictionaryPaymentColumn = {
	AR: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CL: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLNARMA: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLANICX: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLGREEN: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLZUPHARMA: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	MX: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn = {
	AR: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento u.',
		total: 'Precio final u.',
		recipe: 'Receta',
		actions:'Acciones'
	},
	CL: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	MX: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta',actions:'Acciones' },
	CLNARMA: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLANICX: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLGREEN: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLZUPHARMA: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },

};
export const v2_pages_quotation_deprecated_quotation_detail_constants_only_recipe_constant__onlyRecipe = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
	},
	CL: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_constants_product_constant__Product = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
		NP: 'NP', // Venta Libre
		PM: 'PM', // Producto Masivo
		mecanicDiscountOff: 'X % Descuento',
		mecanicNxM: 'N x M',
	},
	CL: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_quotation_deprecated_quotation_detail_constants_status_adapter_constant__statusAdapter = {
	AR: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CL: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLNARMA: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLANICX: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLGREEN: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLZUPHARMA: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	MX: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
};
export const v2_pages_quotation_deprecated_quotation_list_constants_column_titles_constant__ColumnTitles = {
	CL: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	CLNARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	CLANICX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	CLGREEN: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	CLZUPHARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
    detailOrder:'Detalle'
	},
	MX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha y hora',
    detailOrder:'Detalle'
	},

	AR: {
		trx_id: 'N° de orden',
		operation_id: 'N° de reserva',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha y hora',
    detailOrder:'Detalle'
	},
};
export const v2_pages_quotation_deprecated_quotation_list_constants_dictionary_constant__Dictionary = {
	CL: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLNARMA: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLANICX: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLGREEN: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLZUPHARMA: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	MX: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	AR: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Partido',
		Commune: 'Localidad',
		RUT: 'DNI',
	},
};
export const v2_pages_quotation_deprecated_quotation_list_constants_status_constant__statusPreparation = {
	AR: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CL: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLNARMA: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLANICX: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLGREEN: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLZUPHARMA: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	MX: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
};
export const v2_pages_quotation_deprecated_quotation_list_constants_status_description_constant__statusDescription = {
	AR: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CL: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLNARMA: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLANICX: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLGREEN: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CLZUPHARMA: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	MX: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
};
export const v2_pages_quotation_deprecated_quotation_list_constants_type_delivery_constant__typeDelivery = {
	AR: {
		all:'Todas',
		pharmacy: 'Retiro en farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CL: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLNARMA: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLANICX: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLGREEN: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLZUPHARMA: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	MX: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
};
export const v2_pages_quotation_quotation_detail_components_StatusCard_constants_approve_button_constant__approveButton = {
	AR: {
		100: 'Aprobar',
	},
	CL: {
		100: 'Aprobar',
	},
	CLNARMA: {
		100: 'Aprobar',
	},
	CLANICX: {
		100: 'Aprobar',
	},
	CLGREEN: {
		100: 'Aprobar',
	},
	CLZUPHARMA: {
		100: 'Aprobar',
	},
	MX: {
		100: 'Aprobar',
	},

};
export const v2_pages_quotation_quotation_detail_components_StatusCard_constants_cancel_button_constant__cancelButton = {
	AR: {
		100: 'Rechazar',
		400: 'Rechazar',
	},
	CL: {
		100: 'Rechazar',
		400: 'Rechazar',
	},
	CLNARMA: {
		100: 'Rechazar',
		400: 'Rechazar',
	},
	CLANICX: {
		100: 'Rechazar',
		400: 'Rechazar',
	},
	CLGREEN: {
		100: 'Rechazar',
		400: 'Rechazar',
	},
	CLZUPHARMA: {
		100: 'Rechazar',
		400: 'Rechazar',
	},
	MX: {
		100: 'Rechazar',
		400: 'Rechazar',
	},

};
export const v2_pages_quotation_quotation_detail_components_StatusCard_constants_confirm_button_constant__confirmButton = {
	AR: {
		100: 'Continuar',
		400: 'Continuar',
	},
	CL: {
		100: 'Continuar',
		400: 'Continuar',

	},
	CLNARMA: {
		100: 'Continuar',
		400: 'Continuar',

	},
	CLANICX: {
		100: 'Continuar',
		400: 'Continuar',

	},
	CLGREEN: {
		100: 'Continuar',
		400: 'Continuar',

	},
	CLZUPHARMA: {
		100: 'Continuar',
		400: 'Continuar',

	},
	MX: {
		100: 'Continuar',
		400: 'Continuar',
	},

};
export const v2_pages_quotation_quotation_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus = {
	AR: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CL: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CLNARMA: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CLANICX: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CLGREEN: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	CLZUPHARMA: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
	MX: {
		200:200,
		300:300,
		500:500,
		600:600,
	},
};
export const v2_pages_quotation_quotation_detail_components_StatusCard_constants_link_order_button_constant__linkOrderButton = {
	AR: {
    600: 'Ver orden',
	},
  CL: {
    600: 'Ver orden',
    },
    CLNARMA: {
        600: 'Ver orden',
        },
	CLANICX: {
        600: 'Ver orden',
        },
	CLGREEN: {
        600: 'Ver orden',
        },
	CLZUPHARMA: {
        600: 'Ver orden',
        },
	MX: {
    600: 'Ver orden',
	},

};
export const v2_pages_quotation_quotation_detail_components_StatusCard_constants_new_quotation_button_constant__newQuotationButton = {
	AR: {
    500: 'Nueva cotización',
    600: 'Nueva cotización'
	},
  CL: {
    500: 'Nueva cotización',
    600: 'Nueva cotización'
    },
    CLNARMA: {
        500: 'Nueva cotización',
        600: 'Nueva cotización'
        },
	CLANICX: {
        500: 'Nueva cotización',
        600: 'Nueva cotización'
        },
	CLGREEN: {
        500: 'Nueva cotización',
        600: 'Nueva cotización'
        },
	CLZUPHARMA: {
        500: 'Nueva cotización',
        600: 'Nueva cotización'
        },
	MX: {
    500: 'Nueva cotización',
    600: 'Nueva cotización'
	},

};
export const v2_pages_quotation_quotation_detail_components_StatusCard_constants_paid_quotation_button_constant__paidQuotationButton = {
	AR: {
    400: 'Finalizar compra',
	},
  CL: {
    400: 'Finalizar compra',
    },
    CLNARMA: {
        400: 'Finalizar compra',
        },
	CLANICX: {
        400: 'Finalizar compra',
        },
	CLGREEN: {
        400: 'Finalizar compra',
        },
	CLZUPHARMA: {
        400: 'Finalizar compra',
        },
	MX: {
    400: 'Finalizar compra',
	},

};
export const v2_pages_quotation_quotation_detail_components_StatusCard_constants_status_names_constant__statusNames = {
	AR: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Rechazada',
		600: 'Cotización pagada'
	},
	CL: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Rechazada',
		600: 'Cotización pagada'

	},
	CLNARMA: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Rechazada',
		600: 'Cotización pagada'

	},
	CLANICX: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Rechazada',
		600: 'Cotización pagada'

	},
	CLGREEN: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Rechazada',
		600: 'Cotización pagada'

	},
	CLZUPHARMA: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Rechazada',
		600: 'Cotización pagada'

	},
	MX: {
		100: 'Cotización por aprobar',
		200: 'Cotización en revisión',
		300: `Cotización aprobada`,
		400: 'Cotización enviada',
		500: 'Rechazada',
		600: 'Cotización pagada'
	},
};
export const v2_pages_quotation_quotation_detail_components_StatusCard_constants_type_retirement_constant__typeRetirement = {
	AR: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CL: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLNARMA: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLANICX: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLGREEN: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLZUPHARMA: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	MX: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
};
export const v2_pages_quotation_quotation_detail_components_TrackingProgress_constants_status_constant__status = {
	AR: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
		{
			status: 600,
			description: 'Cotización pagada',
		},


	],
	CL: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
		{
			status: 600,
			description: 'Cotización pagada',
		},
	],
	CLNARMA: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
		{
			status: 600,
			description: 'Cotización pagada',
		},
	],
	CLANICX: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
		{
			status: 600,
			description: 'Cotización pagada',
		},
	],
	CLGREEN: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
		{
			status: 600,
			description: 'Cotización pagada',
		},
	],
	CLZUPHARMA: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
		{
			status: 600,
			description: 'Cotización pagada',
		},
	],
	MX: [
		{
			status: 100,
			description: 'Cotización por aprobar',
		},
		{
			status: 200,
			description: 'Cotización en revisión',
		},
		{
			status: 300,
			description: 'Cotización aprobada',
		},
		{
			status: 400,
			description: 'Cotización enviada',
		},
		{
			status: 500,
			description: 'Cotización rechazada',
		},
		{
			status: 600,
			description: 'Cotización pagada',
		},
	],
};
export const v2_pages_quotation_quotation_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement = {
	AR: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Envío a Domicilio',
	},
	CL: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLNARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLANICX: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLGREEN: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLZUPHARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
};
export const v2_pages_quotation_quotation_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns = {
	AR: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'CUIL',
		rut: 'DNI',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'
	},
	CL: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLNARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLANICX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLGREEN: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLZUPHARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	MX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'CURP',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Estado',
		commune: 'Municipio',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
};
export const v2_pages_quotation_quotation_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn = {
	AR: {
		name: 'Nombre y Apellido',
		document: 'Dni',
		email: 'Email',
		gender: 'Género',
		status: 'Status',
		phone:'Teléfono'
	},
	CL: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	MX: {	name: 'Nombre y Apellido', lastname: 'Apellido', document: 'Curp', email: 'Email', gender: 'Género', status: 'Status',phone:'Teléfono' },
	CLNARMA: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLANICX: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLGREEN: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLZUPHARMA: { name: 'Nombre y Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },

};
export const v2_pages_quotation_quotation_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn = {
	AR: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CL: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLNARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLANICX: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLGREEN: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CLZUPHARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	MX: {
		region: 'Estado',
		commune: 'Colonia',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
		municipality: 'Municipio',
	},
};
export const v2_pages_quotation_quotation_detail_constants_dictionary_information_constant__dictionaryInformation = {
	AR: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'
	},
	CL: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLNARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLANICX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLGREEN: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	CLZUPHARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	MX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
};
export const v2_pages_quotation_quotation_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn = {
	AR: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento u.',
		total: 'Precio final u.',
		recipe: 'Receta',
		actions:'Acciones'
	},
	CL: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	MX: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta',actions:'Acciones' },
	CLNARMA: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLANICX: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLGREEN: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLZUPHARMA: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', disscount: 'Descuento', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },

};
export const v2_pages_quotation_quotation_detail_constants_only_recipe_constant__onlyRecipe = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
	},
	CL: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_quotation_quotation_detail_constants_product_constant__Product = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
		NP: 'NP', // Venta Libre
		PM: 'PM', // Producto Masivo
		mecanicDiscountOff: 'X % Descuento',
		mecanicNxM: 'N x M',
	},
	CL: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_quotation_quotation_list_constants_column_titles_constant__ColumnTitles = {
	CL: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Estado',
		createdAt: 'Fecha',
		detailOrder: 'Detalle',
		rut: 'Rut',
		email: 'Correo electrónico'
	},
	MX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha y hora',
    	detailOrder:'Detalle'
	},
	CLNARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de cotización',
		pharmacy:'Farmacia',
		preorder:'N° de pre-orden',
		rut: 'RUT',
		email: 'Correo electrónico',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha',
    	detailOrder:'Detalle'
	},
	CLANICX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de cotización',
		pharmacy:'Farmacia',
		preorder:'N° de pre-orden',
		rut: 'RUT',
		email: 'Correo electrónico',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha',
    	detailOrder:'Detalle'
	},
	CLGREEN: {
		trx_id: 'N° de orden',
		operation_id: 'N° de cotización',
		pharmacy:'Farmacia',
		preorder:'N° de pre-orden',
		rut: 'RUT',
		email: 'Correo electrónico',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha',
    	detailOrder:'Detalle'
	},
	CLZUPHARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de cotización',
		pharmacy:'Farmacia',
		preorder:'N° de pre-orden',
		rut: 'RUT',
		email: 'Correo electrónico',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha',
    	detailOrder:'Detalle'
	},
	AR: {
		trx_id: 'N° de orden',
		operation_id: 'N° de reserva',
		pharmacy:'Farmacia',
		quotation_type: 'Tipo de solicitud',
		status: 'Status',
		createdAt: 'Fecha y hora',
    detailOrder:'Detalle'
	},
};
export const v2_pages_quotation_quotation_list_constants_dictionary_constant__Dictionary = {
	CL: {
		pending: 'Pendiente',
		sended: 'Enviada',
		paid: 'Pagada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	MX: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLNARMA: {
		pending: 'Pendiente',
		sended: 'Enviada',
		paid: 'Pagada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLANICX: {
		pending: 'Pendiente',
		sended: 'Enviada',
		paid: 'Pagada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLGREEN: {
		pending: 'Pendiente',
		sended: 'Enviada',
		paid: 'Pagada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLZUPHARMA: {
		pending: 'Pendiente',
		sended: 'Enviada',
		paid: 'Pagada',
		cancelled: 'Rechazada',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	AR: {
		requested: 'Pendiente',
		completed: 'Aprobada',
		cancelled: 'Rechazada',
		region: 'Partido',
		Commune: 'Localidad',
		RUT: 'DNI',
	},
};
export const v2_pages_quotation_quotation_list_constants_status_constant__statusPreparation = {
	AR: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
	CL: {

		pending: 'pendiente',
		sended: 'enviada',
		paid: 'pagada',
		cancelled: 'rechazada',
	},
	CLNARMA: {
		pending: 'pendiente',
		sended: 'enviada',
		paid: 'pagada',
		cancelled: 'rechazada',
	},
	CLANICX: {
		pending: 'pendiente',
		sended: 'enviada',
		paid: 'pagada',
		cancelled: 'rechazada',
	},
	CLGREEN: {
		pending: 'pendiente',
		sended: 'enviada',
		paid: 'pagada',
		cancelled: 'rechazada',
	},
	CLZUPHARMA: {
		pending: 'pendiente',
		sended: 'enviada',
		paid: 'pagada',
		cancelled: 'rechazada',
	},
	MX: {
		requested: 'pendiente',
		completed: 'aprobada',
		canceled: 'rechazada',
	},
};
export const v2_pages_report_components_ProductReport_constants_language_constant__Language = {
	CL: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	CLNARMA: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	CLANICX: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	CLGREEN: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	CLZUPHARMA: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	MX: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
	AR: {
		total_products: 'Total Productos',
		products_without_price: 'Productos Sin Precio',
		products_without_stock: 'Productos Sin Stock',
		products_without_promotions: 'Productos Sin Promociones',
		total_general_products: 'Total Productos General',
	},
};
export const v2_pages_report_constants_language_constant__Language = {
	CL: {
		loading: 'Cargando ...',
		title: 'Reporte de Productos',
	},
	CLNARMA: {
		loading: 'Cargando ...',
		title: 'Reporte de Productos',
	},
	CLANICX: {
		loading: 'Cargando ...',
		title: 'Reporte de Productos',
	},
	CLGREEN: {
		loading: 'Cargando ...',
		title: 'Reporte de Productos',
	},
	CLZUPHARMA: {
		loading: 'Cargando ...',
		title: 'Reporte de Productos',
	},
	MX: {
		loading: 'Cargando ...',
		title: 'Reporte de Productos',
	},
	AR: {
		loading: 'Cargando ...',
		title: 'Reporte de Productos (AR)',
	},
};
export const v2_pages_reserve_reserve_detail_components_DropdownTable_constants_product_detail_constant__productDetail = {
	AR: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
	},
	CL: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
	},
	CLNARMA: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
	},
	CLANICX: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
	},
	CLGREEN: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
	},
	CLZUPHARMA: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
	},
	MX: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
	},
};
export const v2_pages_reserve_reserve_detail_components_DropdownTable_constants_status_constant__status = {
	AR: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CL: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CLNARMA: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CLANICX: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CLGREEN: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CLZUPHARMA: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	MX: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
};
export const v2_pages_reserve_reserve_detail_components_ReserveProgress_handle_type_retirement_handle__typeRetirement = {
	AR: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Envío a Domicilio',
	},
	CL: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLNARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLANICX: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLGREEN: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLZUPHARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	MX: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
};
export const v2_pages_reserve_reserve_detail_components_StatusCard_constants_notifications_constant__notifications = {
	AR: {
		approved: 'Estado cambiado a Aprobada',
		rejected: 'Estado cambiado a Rechazada',
		error: 'Ha ocurrido un error',
	},
	CL: { approved: 'Estado cambiado a Aprobada', rejected: 'Estado cambiado a Rechazada', error: 'Ha ocurrido un error' },
	MX: { approved: 'Estado cambiado a Aprobada', rejected: 'Estado cambiado a Rechazada', error: 'Ha ocurrido un error' },
	CLNARMA: { approved: 'Estado cambiado a Aprobada', rejected: 'Estado cambiado a Rechazada', error: 'Ha ocurrido un error' },
	CLANICX: { approved: 'Estado cambiado a Aprobada', rejected: 'Estado cambiado a Rechazada', error: 'Ha ocurrido un error' },
	CLGREEN: { approved: 'Estado cambiado a Aprobada', rejected: 'Estado cambiado a Rechazada', error: 'Ha ocurrido un error' },
	CLZUPHARMA: { approved: 'Estado cambiado a Aprobada', rejected: 'Estado cambiado a Rechazada', error: 'Ha ocurrido un error' },

};
export const v2_pages_reserve_reserve_detail_components_StatusCard_constants_options_constant__options = {
	AR: [
		{
			value: 'Problemas con la receta',
			label: 'Problemas con la receta',
		},
		{
			value: 'Falta de stock en los productos reservados',
			label: 'Falta de stock en los productos reservados',
		},
		{
			value: 'Otros',
			label: 'Otros',
		},
	],
	CL: [
		{
			value: 'Problemas con la receta',
			label: 'Problemas con la receta',
		},
		{
			value: 'Falta de stock en los productos reservados',
			label: 'Falta de stock en los productos reservados',
		},
		{
			value: 'Otros',
			label: 'Otros',
		},
	],
	CLNARMA: [
		{
			value: 'Problemas con la receta',
			label: 'Problemas con la receta',
		},
		{
			value: 'Falta de stock en los productos reservados',
			label: 'Falta de stock en los productos reservados',
		},
		{
			value: 'Otros',
			label: 'Otros',
		},
	],
	CLANICX: [
		{
			value: 'Problemas con la receta',
			label: 'Problemas con la receta',
		},
		{
			value: 'Falta de stock en los productos reservados',
			label: 'Falta de stock en los productos reservados',
		},
		{
			value: 'Otros',
			label: 'Otros',
		},
	],
	CLGREEN: [
		{
			value: 'Problemas con la receta',
			label: 'Problemas con la receta',
		},
		{
			value: 'Falta de stock en los productos reservados',
			label: 'Falta de stock en los productos reservados',
		},
		{
			value: 'Otros',
			label: 'Otros',
		},
	],
	CLZUPHARMA: [
		{
			value: 'Problemas con la receta',
			label: 'Problemas con la receta',
		},
		{
			value: 'Falta de stock en los productos reservados',
			label: 'Falta de stock en los productos reservados',
		},
		{
			value: 'Otros',
			label: 'Otros',
		},
	],
	MX: [
		{
			value: 'Problemas con la receta',
			label: 'Problemas con la receta',
		},
		{
			value: 'Falta de stock en los productos reservados',
			label: 'Falta de stock en los productos reservados',
		},
		{
			value: 'Otros',
			label: 'Otros',
		},
	],
};
export const v2_pages_reserve_reserve_detail_components_StatusCard_constants_status_names_constant__statusNames = {
	AR: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CL: { 100: 'Por aprobar', 200: 'Aprobada', 300: 'Rechazada', 400: 'Completada' },
	MX: { 100: 'Por aprobar', 200: 'Aprobada', 300: 'Rechazada', 400: 'Completada' },
	CLNARMA: { 100: 'Por aprobar', 200: 'Aprobada', 300: 'Rechazada', 400: 'Completada' },
	CLANICX: { 100: 'Por aprobar', 200: 'Aprobada', 300: 'Rechazada', 400: 'Completada' },
	CLGREEN: { 100: 'Por aprobar', 200: 'Aprobada', 300: 'Rechazada', 400: 'Completada' },
	CLZUPHARMA: { 100: 'Por aprobar', 200: 'Aprobada', 300: 'Rechazada', 400: 'Completada' },

};
export const v2_pages_reserve_reserve_detail_constants_data_steps_constant__dataSteps = {
	AR: [
		{
			status: 100,
			title: 'Por aprobar',
		},
		{
			status: 200,
			title: 'Aprobada',
		},
		{
			status: 300,
			title: 'Rechazada',
		},
		{
			status: 400,
			title: 'Completada',
		},
	],
	CL: [
		{
			status: 100,
			title: 'Por aprobar',
		},
		{
			status: 200,
			title: 'Aprobada',
		},
		{
			status: 300,
			title: 'Rechazada',
		},
		{
			status: 400,
			title: 'Completada',
		},
	],
	CLNARMA: [
		{
			status: 100,
			title: 'Por aprobar',
		},
		{
			status: 200,
			title: 'Aprobada',
		},
		{
			status: 300,
			title: 'Rechazada',
		},
		{
			status: 400,
			title: 'Completada',
		},
	],
	CLANICX: [
		{
			status: 100,
			title: 'Por aprobar',
		},
		{
			status: 200,
			title: 'Aprobada',
		},
		{
			status: 300,
			title: 'Rechazada',
		},
		{
			status: 400,
			title: 'Completada',
		},
	],
	CLGREEN: [
		{
			status: 100,
			title: 'Por aprobar',
		},
		{
			status: 200,
			title: 'Aprobada',
		},
		{
			status: 300,
			title: 'Rechazada',
		},
		{
			status: 400,
			title: 'Completada',
		},
	],
	CLZUPHARMA: [
		{
			status: 100,
			title: 'Por aprobar',
		},
		{
			status: 200,
			title: 'Aprobada',
		},
		{
			status: 300,
			title: 'Rechazada',
		},
		{
			status: 400,
			title: 'Completada',
		},
	],
	MX: [
		{
			status: 100,
			title: 'Por aprobar',
		},
		{
			status: 200,
			title: 'Aprobada',
		},
		{
			status: 300,
			title: 'Rechazada',
		},
		{
			status: 400,
			title: 'Completada',
		},
	],
};
export const v2_pages_reserve_reserve_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn = {
	AR: {
		name: 'Nombre',
		lastname: 'Apellido',
		document: 'Dni',
		email: 'Email',
		phone: 'Telefono',
		status: 'Status',
	},
	CL: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', phone: 'Telefono', status: 'Status' },
	MX: { name: 'Nombre', lastname: 'Apellido', document: 'Curp', email: 'Email', phone: 'Telefono', status: 'Status' },
	CLNARMA: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', phone: 'Telefono', status: 'Status' },
	CLANICX: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', phone: 'Telefono', status: 'Status' },
	CLGREEN: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', phone: 'Telefono', status: 'Status' },
	CLZUPHARMA: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', phone: 'Telefono', status: 'Status' },

};
export const v2_pages_reserve_reserve_detail_constants_dictionary_constant__Dictionary = {
	CL: {
		pending: 'En Preparación',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'Rut',
	},
	CLNARMA: {
		pending: 'En Preparación',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'Rut',
	},
	CLANICX: {
		pending: 'En Preparación',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'Rut',
	},
	CLGREEN: {
		pending: 'En Preparación',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'Rut',
	},
	CLZUPHARMA: {
		pending: 'En Preparación',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'Rut',
	},
	MX: {
		pending: 'En Preparación',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'Rut',
	},

	AR: {
		pending: 'En Preparación AR',
		region: 'Partido',
		Commune: 'Localidad',
		Rut: 'Dni',
	},
};
export const v2_pages_reserve_reserve_detail_constants_dictionary_coverage_columns_constant__dictionaryCoverageColumn = {
	AR: {
		coverage_type: 'Tipo de cobertura',
		health_coverage: 'Cobertura de salud',
		plan: 'Plan',
		social_number: 'N° de socio',
		token: 'Token',
	},
	CL: { coverage_type: 'Tipo de cobertura', health_coverage: 'Cobertura de salud', plan: 'Plan', social_number: 'N° de socio', token: 'Token' },
	MX: { coverage_type: 'Tipo de cobertura', health_coverage: 'Cobertura de salud', plan: 'Plan', social_number: 'N° de socio', token: 'Token' },
	CLNARMA: { coverage_type: 'Tipo de cobertura', health_coverage: 'Cobertura de salud', plan: 'Plan', social_number: 'N° de socio', token: 'Token' },
	CLANICX: { coverage_type: 'Tipo de cobertura', health_coverage: 'Cobertura de salud', plan: 'Plan', social_number: 'N° de socio', token: 'Token' },
	CLGREEN: { coverage_type: 'Tipo de cobertura', health_coverage: 'Cobertura de salud', plan: 'Plan', social_number: 'N° de socio', token: 'Token' },
	CLZUPHARMA: { coverage_type: 'Tipo de cobertura', health_coverage: 'Cobertura de salud', plan: 'Plan', social_number: 'N° de socio', token: 'Token' },

};
export const v2_pages_reserve_reserve_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryColumn = {
	AR: {
		operation_id: 'ID tracking',
		schedule_selected: 'Fecha estimada de entrega',
		type_retirement: 'Tipo de Entrega',
		trx_id: 'Numero orden',
		commune: 'Comuna',
		address: 'Dirección',
		hometype: 'Tipo de vivienda',
		reference: 'Referencia',
		floor: 'Piso/dpto./torre',
		region:'Región'
	},
	CL: {
		operation_id: 'ID tracking',
		schedule_selected: 'Fecha estimada de entrega',
		type_retirement: 'Tipo de Entrega',
		trx_id: 'Numero orden',
		commune: 'Comuna',
		address: 'Dirección',
		hometype: 'Tipo de vivienda',
		reference: 'Referencia',
		floor: 'Piso/dpto./torre',
		region:'Región'

	},
	CLNARMA: {
		operation_id: 'ID tracking',
		schedule_selected: 'Fecha estimada de entrega',
		type_retirement: 'Tipo de Entrega',
		trx_id: 'Numero orden',
		commune: 'Comuna',
		address: 'Dirección',
		hometype: 'Tipo de vivienda',
		reference: 'Referencia',
		floor: 'Piso/dpto./torre',
		region:'Región'

	},
	CLANICX: {
		operation_id: 'ID tracking',
		schedule_selected: 'Fecha estimada de entrega',
		type_retirement: 'Tipo de Entrega',
		trx_id: 'Numero orden',
		commune: 'Comuna',
		address: 'Dirección',
		hometype: 'Tipo de vivienda',
		reference: 'Referencia',
		floor: 'Piso/dpto./torre',
		region:'Región'

	},
	CLGREEN: {
		operation_id: 'ID tracking',
		schedule_selected: 'Fecha estimada de entrega',
		type_retirement: 'Tipo de Entrega',
		trx_id: 'Numero orden',
		commune: 'Comuna',
		address: 'Dirección',
		hometype: 'Tipo de vivienda',
		reference: 'Referencia',
		floor: 'Piso/dpto./torre',
		region:'Región'

	},
	CLZUPHARMA: {
		operation_id: 'ID tracking',
		schedule_selected: 'Fecha estimada de entrega',
		type_retirement: 'Tipo de Entrega',
		trx_id: 'Numero orden',
		commune: 'Comuna',
		address: 'Dirección',
		hometype: 'Tipo de vivienda',
		reference: 'Referencia',
		floor: 'Piso/dpto./torre',
		region:'Región'

	},
	MX: {
		operation_id: 'ID tracking',
		schedule_selected: 'Fecha estimada de entrega',
		type_retirement: 'Tipo de Entrega',
		trx_id: 'Numero orden',
		commune: 'Comuna',
		address: 'Dirección',
		hometype: 'Tipo de vivienda',
		reference: 'Referencia',
		floor: 'Piso/dpto./torre',
		region:'Región'

	},
};
export const v2_pages_reserve_reserve_detail_constants_dictionary_information_constant__dictionaryInformation = {
	AR: {
		client: 'Información del cliente',
		order: 'Información del pedido',
		coverage: 'Cobertura del cliente',
		products: 'Productos',
		stock: 'Revisión de stock',
		home_delivery: 'Información de envío a domicilio',
	},
	CL: {
		client: 'Información del cliente',
		order: 'Información del pedido',
		coverage: 'Cobertura del cliente',
		products: 'Productos',
		stock: 'Revisión de stock',
		home_delivery: 'Información de envío a domicilio',
	},
	CLNARMA: {
		client: 'Información del cliente',
		order: 'Información del pedido',
		coverage: 'Cobertura del cliente',
		products: 'Productos',
		stock: 'Revisión de stock',
		home_delivery: 'Información de envío a domicilio',
	},
	CLANICX: {
		client: 'Información del cliente',
		order: 'Información del pedido',
		coverage: 'Cobertura del cliente',
		products: 'Productos',
		stock: 'Revisión de stock',
		home_delivery: 'Información de envío a domicilio',
	},
	CLGREEN: {
		client: 'Información del cliente',
		order: 'Información del pedido',
		coverage: 'Cobertura del cliente',
		products: 'Productos',
		stock: 'Revisión de stock',
		home_delivery: 'Información de envío a domicilio',
	},
	CLZUPHARMA: {
		client: 'Información del cliente',
		order: 'Información del pedido',
		coverage: 'Cobertura del cliente',
		products: 'Productos',
		stock: 'Revisión de stock',
		home_delivery: 'Información de envío a domicilio',
	},
	MX: {
		client: 'Información del cliente',
		order: 'Información del pedido',
		coverage: 'Cobertura del cliente',
		products: 'Productos',
		stock: 'Revisión de stock',
		home_delivery: 'Información de envío a domicilio',
	},
};
export const v2_pages_reserve_reserve_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn = {
	AR: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento u.',
		total: 'Precio final u.',
		total_products: 'Precio final total',
		recipe: 'Receta',
		actions:'Acciones'
	},
	CL: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final u.',
		total_products: 'Precio final total',
		recipe: 'Receta',
		actions:'Acciones'
	},
	CLNARMA: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final u.',
		total_products: 'Precio final total',
		recipe: 'Receta',
		actions:'Acciones'
	},
	CLANICX: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final u.',
		total_products: 'Precio final total',
		recipe: 'Receta',
		actions:'Acciones'
	},
	CLGREEN: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final u.',
		total_products: 'Precio final total',
		recipe: 'Receta',
		actions:'Acciones'
	},
	CLZUPHARMA: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final u.',
		total_products: 'Precio final total',
		recipe: 'Receta',
		actions:'Acciones'
	},
	MX: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento',
		total: 'Precio final u.',
		total_products: 'Precio final total',
		recipe: 'Receta',
		actions:'Acciones'
	},
};
export const v2_pages_reserve_reserve_detail_constants_notifications_constant__notifications = {
	AR: {
		approved: 'Cambio realizado con éxito',
		rejected: 'Cambio realizado con éxito',
		error: 'Ha ocurrido un error',
		link: 'No se pudo generar el link de pago',
	},
	CL: {
		approved: 'Cambio realizado con éxito',
		rejected: 'Cambio realizado con éxito',
		error: 'Ha ocurrido un error',
		link: 'No se pudo generar el lsink de pago',
	},
	CLNARMA: {
		approved: 'Cambio realizado con éxito',
		rejected: 'Cambio realizado con éxito',
		error: 'Ha ocurrido un error',
		link: 'No se pudo generar el lsink de pago',
	},
	CLANICX: {
		approved: 'Cambio realizado con éxito',
		rejected: 'Cambio realizado con éxito',
		error: 'Ha ocurrido un error',
		link: 'No se pudo generar el lsink de pago',
	},
	CLGREEN: {
		approved: 'Cambio realizado con éxito',
		rejected: 'Cambio realizado con éxito',
		error: 'Ha ocurrido un error',
		link: 'No se pudo generar el lsink de pago',
	},
	CLZUPHARMA: {
		approved: 'Cambio realizado con éxito',
		rejected: 'Cambio realizado con éxito',
		error: 'Ha ocurrido un error',
		link: 'No se pudo generar el lsink de pago',
	},
	MX: {
		approved: 'Cambio realizado con éxito',
		rejected: 'Cambio realizado con éxito',
		error: 'Ha ocurrido un error',
		link: 'No se pudo generar el lsink de pago',
	},
};
export const v2_pages_reserve_reserve_detail_constants_only_recipe_constant__onlyRecipe = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
	},
	CL: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_reserve_reserve_list_constants_column_titles_constant__ColumnTitles = {
	CL: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	CLNARMA: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	CLANICX: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	CLGREEN: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	CLZUPHARMA: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
	MX: {
		operation_id: 'N° de solicitud',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},

	AR: {
		operation_id: 'N° de reserva',
		trx_id: 'N° de orden',
		type_document: 'Tipo de solicitud',
		status: 'Status',
		created_at: 'Fecha y hora',
		detail: 'Detalle',
		pharmacy: 'Farmacia',
	},
};
export const v2_pages_reserve_reserve_list_constants_status_names_constant__statusNames = {
	AR: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CL: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CLNARMA: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CLANICX: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CLGREEN: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	CLZUPHARMA: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
	MX: {
		100: 'Por aprobar',
		200: 'Aprobada',
		300: 'Rechazada',
		400: 'Completada',
	},
};
export const v2_pages_stock_constants_select_all_constant__SelectAll = {
	AR: { label: 'Todas', value: 'all' },
	CL: { label: 'Todas', value: 'all' },
	MX: { label: 'Todas', value: 'all' },
	CLNARMA: { label: 'Todas', value: 'all' },
	CLANICX: { label: 'Todas', value: 'all' },
	CLGREEN: { label: 'Todas', value: 'all' },
	CLZUPHARMA: { label: 'Todas', value: 'all' },

};
export const v2_pages_tracking_order_detail_components_DropdownTable_constants_product_detail_constant__productDetail = {
	AR: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
		prescryption_type: 'Tipo de receta: ',
		indication:'Especificaciones'
	},
	CL: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
		prescryption_type: 'Tipo de receta: ',
		indication:'Especificaciones'


	},
	CLNARMA: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
		prescryption_type: 'Tipo de receta: ',
		indication:'Especificaciones'


	},
	CLANICX: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
		prescryption_type: 'Tipo de receta: ',
		indication:'Especificaciones'


	},
	CLGREEN: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
		prescryption_type: 'Tipo de receta: ',
		indication:'Especificaciones'


	},
	CLZUPHARMA: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
		prescryption_type: 'Tipo de receta: ',
		indication:'Especificaciones'


	},
	MX: {
		code_internal: 'Sku farmacia:',
		id_pharol: 'Sku general:',
		shipment: 'Condiciones de envío:',
		temperature: 'Temperatura de salida:',
		humidity: 'Humedad de salida:',
		laboratory: 'Laboratorio:',
		bioequivalent: 'Bioequivalente:',
		promotion: 'Promociones:',
		recipe: 'Estado de receta:',
		prescryption_type: 'Tipo de receta: ',
		indication:'Especificaciones'

	},
};
export const v2_pages_tracking_order_detail_components_DropdownTable_constants_status_constant__status = {
	AR: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CL: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CLNARMA: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CLANICX: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CLGREEN: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	CLZUPHARMA: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
	MX: {
		100: 'Pendiente de aprobación',
		200: 'Aprobado',
		300: 'Rechazado',
		400: 'Completado',
	},
};
export const v2_pages_tracking_order_detail_components_RecipeModal_constants_select_constant__selectConstants = {
	AR: [
		{ label: 'Medicamento en receta es distinto al medicamento comprado', value: 'Medicamento en receta es distinto al medicamento comprado' },
		{ label: 'Profesional no habilitado para prescribir tratamiento', value: 'Profesional no habilitado para prescribir tratamiento' },
		{ label: 'Receta desenfocada', value: 'Receta desenfocada' },
		{ label: 'Receta incompleta', value: 'Receta incompleta' },
		{ label: 'Cantidad comprada supera días de tratamiento', value: 'Cantidad comprada supera días de tratamiento' },
		{ label: 'Tratamiento no vigente', value: 'Tratamiento no vigente' },
		{ label: 'Otro', value: 'Otro' },
	],
	CL: [
		{ label: 'Medicamento en receta es distinto al medicamento comprado', value: 'Medicamento en receta es distinto al medicamento comprado' },
		{ label: 'Profesional no habilitado para prescribir tratamiento', value: 'Profesional no habilitado para prescribir tratamiento' },
		{ label: 'Receta desenfocada', value: 'Receta desenfocada' },
		{ label: 'Receta incompleta', value: 'Receta incompleta' },
		{ label: 'Cantidad comprada supera días de tratamiento', value: 'Cantidad comprada supera días de tratamiento' },
		{ label: 'Tratamiento no vigente', value: 'Tratamiento no vigente' },
		{ label: 'Otro', value: 'Otro' },
	],
	CLNARMA: [
		{ label: 'Medicamento en receta es distinto al medicamento comprado', value: 'Medicamento en receta es distinto al medicamento comprado' },
		{ label: 'Profesional no habilitado para prescribir tratamiento', value: 'Profesional no habilitado para prescribir tratamiento' },
		{ label: 'Receta desenfocada', value: 'Receta desenfocada' },
		{ label: 'Receta incompleta', value: 'Receta incompleta' },
		{ label: 'Cantidad comprada supera días de tratamiento', value: 'Cantidad comprada supera días de tratamiento' },
		{ label: 'Tratamiento no vigente', value: 'Tratamiento no vigente' },
		{ label: 'Otro', value: 'Otro' },
	],
	CLANICX: [
		{ label: 'Medicamento en receta es distinto al medicamento comprado', value: 'Medicamento en receta es distinto al medicamento comprado' },
		{ label: 'Profesional no habilitado para prescribir tratamiento', value: 'Profesional no habilitado para prescribir tratamiento' },
		{ label: 'Receta desenfocada', value: 'Receta desenfocada' },
		{ label: 'Receta incompleta', value: 'Receta incompleta' },
		{ label: 'Cantidad comprada supera días de tratamiento', value: 'Cantidad comprada supera días de tratamiento' },
		{ label: 'Tratamiento no vigente', value: 'Tratamiento no vigente' },
		{ label: 'Otro', value: 'Otro' },
	],
	CLGREEN: [
		{ label: 'Medicamento en receta es distinto al medicamento comprado', value: 'Medicamento en receta es distinto al medicamento comprado' },
		{ label: 'Profesional no habilitado para prescribir tratamiento', value: 'Profesional no habilitado para prescribir tratamiento' },
		{ label: 'Receta desenfocada', value: 'Receta desenfocada' },
		{ label: 'Receta incompleta', value: 'Receta incompleta' },
		{ label: 'Cantidad comprada supera días de tratamiento', value: 'Cantidad comprada supera días de tratamiento' },
		{ label: 'Tratamiento no vigente', value: 'Tratamiento no vigente' },
		{ label: 'Otro', value: 'Otro' },
	],
	CLZUPHARMA: [
		{ label: 'Medicamento en receta es distinto al medicamento comprado', value: 'Medicamento en receta es distinto al medicamento comprado' },
		{ label: 'Profesional no habilitado para prescribir tratamiento', value: 'Profesional no habilitado para prescribir tratamiento' },
		{ label: 'Receta desenfocada', value: 'Receta desenfocada' },
		{ label: 'Receta incompleta', value: 'Receta incompleta' },
		{ label: 'Cantidad comprada supera días de tratamiento', value: 'Cantidad comprada supera días de tratamiento' },
		{ label: 'Tratamiento no vigente', value: 'Tratamiento no vigente' },
		{ label: 'Otro', value: 'Otro' },
	],
	MX: [
		{ label: 'Medicamento en receta es distinto al medicamento comprado', value: 'Medicamento en receta es distinto al medicamento comprado' },
		{ label: 'Profesional no habilitado para prescribir tratamiento', value: 'Profesional no habilitado para prescribir tratamiento' },
		{ label: 'Receta desenfocada', value: 'Receta desenfocada' },
		{ label: 'Receta incompleta', value: 'Receta incompleta' },
		{ label: 'Cantidad comprada supera días de tratamiento', value: 'Cantidad comprada supera días de tratamiento' },
		{ label: 'Tratamiento no vigente', value: 'Tratamiento no vigente' },
		{ label: 'Otro', value: 'Otro' },
	],
};
export const v2_pages_tracking_order_detail_components_RecipeModal_constants_select_qf_constant__selectQfConstants = {
	AR: [
		{ label: 'Aprobado por criterio QF', value: 'Aprobado por criterio QF.' },
		{ label: 'Otro', value: 'Otro.' },
	],
	CL: [
		{ label: 'Aprobado por criterio QF', value: 'Aprobado por criterio QF.' },
		{ label: 'Otro', value: 'Otro.' },
	],
	CLNARMA: [
		{ label: 'Aprobado por criterio QF', value: 'Aprobado por criterio QF.' },
		{ label: 'Otro', value: 'Otro.' },
	],
	CLANICX: [
		{ label: 'Aprobado por criterio QF', value: 'Aprobado por criterio QF.' },
		{ label: 'Otro', value: 'Otro.' },
	],
	CLGREEN: [
		{ label: 'Aprobado por criterio QF', value: 'Aprobado por criterio QF.' },
		{ label: 'Otro', value: 'Otro.' },
	],
	CLZUPHARMA: [
		{ label: 'Aprobado por criterio QF', value: 'Aprobado por criterio QF.' },
		{ label: 'Otro', value: 'Otro.' },
	],
	MX: [
		{ label: 'Aprobado por criterio QF', value: 'Aprobado por criterio QF.' },
		{ label: 'Otro', value: 'Otro.' },
	],
};
export const v2_pages_tracking_order_detail_components_StatusCard_constants_approve_button_constant__approveButton = {
	AR: {
		1: 'APROBAR',
		101: 'APROBAR',
		2: 'CONTINUAR',
		201: 'CONTINUAR',
		3: 'CONTINUAR',
		4: 'CONFIRMAR ENTREGA',
	},
	CL: { 1: 'APROBAR', 101: 'APROBAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONFIRMAR ENTREGA' },
	MX: { 1: 'APROBAR', 101: 'APROBAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONFIRMAR ENTREGA' },
	CLNARMA: { 1: 'APROBAR', 101: 'APROBAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONFIRMAR ENTREGA' },
	CLANICX: { 1: 'APROBAR', 101: 'APROBAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONFIRMAR ENTREGA' },
	CLGREEN: { 1: 'APROBAR', 101: 'APROBAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONFIRMAR ENTREGA' },
	CLZUPHARMA: { 1: 'APROBAR', 101: 'APROBAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONFIRMAR ENTREGA' },

};
export const v2_pages_tracking_order_detail_components_StatusCard_constants_cancel_button_constant__cancelButton = {
	AR: {
		1: 'CANCELAR COMPRA',
		101: 'CANCELAR COMPRA',
		2: 'CANCELAR COMPRA',
		201: 'CANCELAR COMPRA',
		3: 'CANCELAR COMPRA',
		4: 'CANCELAR COMPRA',
	},
	CL: { 1: 'CANCELAR COMPRA', 101: 'CANCELAR COMPRA', 2: 'CANCELAR COMPRA', 201: 'CANCELAR COMPRA', 3: 'CANCELAR COMPRA', 4: 'CANCELAR COMPRA' },
	MX: { 1: 'CANCELAR COMPRA', 101: 'CANCELAR COMPRA', 2: 'CANCELAR COMPRA', 201: 'CANCELAR COMPRA', 3: 'CANCELAR COMPRA', 4: 'CANCELAR COMPRA' },
	CLNARMA: { 1: 'CANCELAR COMPRA', 101: 'CANCELAR COMPRA', 2: 'CANCELAR COMPRA', 201: 'CANCELAR COMPRA', 3: 'CANCELAR COMPRA', 4: 'CANCELAR COMPRA' },
	CLANICX: { 1: 'CANCELAR COMPRA', 101: 'CANCELAR COMPRA', 2: 'CANCELAR COMPRA', 201: 'CANCELAR COMPRA', 3: 'CANCELAR COMPRA', 4: 'CANCELAR COMPRA' },
	CLGREEN: { 1: 'CANCELAR COMPRA', 101: 'CANCELAR COMPRA', 2: 'CANCELAR COMPRA', 201: 'CANCELAR COMPRA', 3: 'CANCELAR COMPRA', 4: 'CANCELAR COMPRA' },
	CLZUPHARMA: { 1: 'CANCELAR COMPRA', 101: 'CANCELAR COMPRA', 2: 'CANCELAR COMPRA', 201: 'CANCELAR COMPRA', 3: 'CANCELAR COMPRA', 4: 'CANCELAR COMPRA' },

};
export const v2_pages_tracking_order_detail_components_StatusCard_constants_confirm_button_constant__confirmButton = {
  AR: {
		1: 'CONTINUAR',
		101: 'CONTINUAR',
		2: 'CONTINUAR',
		201: 'CONTINUAR',
		3: 'CONTINUAR',
		4: 'CONTINUAR',
	},
	CL: { 1: 'CONTINUAR', 101: 'CONTINUAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONTINUAR' },
	MX: { 1: 'CONTINUAR', 101: 'CONTINUAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONTINUAR' },
	CLNARMA: { 1: 'CONTINUAR', 101: 'CONTINUAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONTINUAR' },
	CLANICX: { 1: 'CONTINUAR', 101: 'CONTINUAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONTINUAR' },
	CLGREEN: { 1: 'CONTINUAR', 101: 'CONTINUAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONTINUAR' },
	CLZUPHARMA: { 1: 'CONTINUAR', 101: 'CONTINUAR', 2: 'CONTINUAR', 201: 'CONTINUAR', 3: 'CONTINUAR', 4: 'CONTINUAR' },

};
export const v2_pages_tracking_order_detail_components_StatusCard_constants_data_steps_constant__dataSteps = {
	AR: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de armado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido cancelado',
		},
		{
			status: 9,
			title: 'Entrega confirmada',
		},
	],
	CL: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLNARMA: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLANICX: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLGREEN: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	CLZUPHARMA: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
	MX: [
		{
			status: 1,
			title: 'Por aprobar',
		},
		{
			status: 101,
			title: 'En mediación',
		},
		{
			status: 2,
			title: 'Aprobada',
		},
		{
			status: 201,
			title: 'Por confirmar',
		},
		{
			status: 3,
			title: 'En proceso de empacado',
		},
		{
			status: 4,
			title: 'Listo para retiro',
		},
		{
			status: 5,
			title: 'Pedido en camino',
		},
		{
			status: 6,
			title: 'Pedido entregado',
		},
		{
			status: 8,
			title: 'Pedido anulado',
		},
		{
			status: 9,
			title: 'Pedido confirmado',
		},
	],
};
export const v2_pages_tracking_order_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus = {
	AR: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CL: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
	CLNARMA: {
		5: 5,
		6: 6,
		8: 8,
	},
	CLANICX: {
		5: 5,
		6: 6,
		8: 8,
	},
	CLGREEN: {
		5: 5,
		6: 6,
		8: 8,
	},
	CLZUPHARMA: {
		5: 5,
		6: 6,
		8: 8,
	},
	MX: {
		4: 4,
		5: 5,
		6: 6,
		8: 8,
	},
};
export const v2_pages_tracking_order_detail_components_StatusCard_constants_payment_method_constants__paymentMethod = {
    CL:{
        MP:"mercadopago-cl"
    },
    CLNARMA:{
        MP:"mercadopago-cl"
    },
	CLANICX: {
        MP:"mercadopago-cl"
    },
	CLGREEN: {
        MP:"mercadopago-cl"
    },
	CLZUPHARMA: {
        MP:"mercadopago-cl"
    },
    MX:{
        MP:"mercadopago-mx"
    }
};
export const v2_pages_tracking_order_detail_components_StatusCard_constants_status_names_constant__statusNames = {
	AR: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: `Aprobada`,
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: `Pedido en camino`,
		6: 'Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CL: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: `Aprobada`,
		201: 'Por confirmar',
		3: 'En proceso de empacado',
		4: 'Listo para retiro',
		5: `Pedido en camino`,
		6: 'Pedido entregado',
		8: 'Pedido anulado',
		9: 'Pedido confirmado',
	},
	CLNARMA: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: `Aprobada`,
		201: 'Por confirmar',
		3: 'En proceso de empacado',
		4: 'Listo para retiro',
		5: `Pedido en camino`,
		6: 'Pedido entregado',
		8: 'Pedido anulado',
		9: 'Pedido confirmado',
	},
	CLANICX: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: `Aprobada`,
		201: 'Por confirmar',
		3: 'En proceso de empacado',
		4: 'Listo para retiro',
		5: `Pedido en camino`,
		6: 'Pedido entregado',
		8: 'Pedido anulado',
		9: 'Pedido confirmado',
	},
	CLGREEN: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: `Aprobada`,
		201: 'Por confirmar',
		3: 'En proceso de empacado',
		4: 'Listo para retiro',
		5: `Pedido en camino`,
		6: 'Pedido entregado',
		8: 'Pedido anulado',
		9: 'Pedido confirmado',
	},
	CLZUPHARMA: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: `Aprobada`,
		201: 'Por confirmar',
		3: 'En proceso de empacado',
		4: 'Listo para retiro',
		5: `Pedido en camino`,
		6: 'Pedido entregado',
		8: 'Pedido anulado',
		9: 'Pedido confirmado',
	},
	MX: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: `Aprobada`,
		201: 'Por confirmar',
		3: 'En proceso de empacado',
		4: 'Listo para retiro',
		5: `Pedido en camino`,
		6: 'Pedido entregado',
		8: 'Pedido anulado',
		9: 'Pedido confirmado',
	},
};
export const v2_pages_tracking_order_detail_components_StatusCard_constants_type_retirement_constant__typeRetirement = {
	AR: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CL: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLNARMA: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLANICX: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLGREEN: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	CLZUPHARMA: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
	MX: {
		pharmacy: 'farmacia',
		home: 'domicilio',
	},
};
export const v2_pages_tracking_order_detail_components_TrackingProgress_constants_status_constant__status = {
	AR: [
		{
			status: 1,
			description: 'Por aprobar',
		},
		{
			status: 101,
			description: 'En mediación',
		},
		{
			status: 2,
			description: 'Aprobada',
		},
		{
			status: 201,
			description: 'Por confirmar',
		},
		{
			status: 3,
			description: 'En Proceso de armado',
		},
		{
			status: 4,
			description: 'Listo para retiro',
		},
		{
			status: 5,
			description: 'Pedido en camino',
		},
		{
			status: 6,
			description: 'Pedido entregado',
		},
		{
			status: 8,
			description: 'Pedido cancelado',
		},
		{
			status: 9,
			description: 'Entrega confirmada',
		},

	],
	CL: [
		{
			status: 1,
			description: 'Por aprobar',
		},
		{
			status: 101,
			description: 'En mediación',
		},
		{
			status: 2,
			description: 'Aprobada',
		},
		{
			status: 201,
			description: 'Por confirmar',
		},
		{
			status: 3,
			description: 'En Proceso de empacado',
		},
		{
			status: 4,
			description: 'Listo para retiro',
		},
		{
			status: 5,
			description: 'Pedido en camino',
		},
		{
			status: 6,
			description: 'Pedido entregado',
		},
		{
			status: 8,
			description: 'Pedido anulado',
		},
		{
			status: 9,
			description: 'Pedido confirmado',
		},

	],
	CLNARMA: [
		{
			status: 1,
			description: 'Por aprobar',
		},
		{
			status: 101,
			description: 'En mediación',
		},
		{
			status: 2,
			description: 'Aprobada',
		},
		{
			status: 201,
			description: 'Por confirmar',
		},
		{
			status: 3,
			description: 'En Proceso de empacado',
		},
		{
			status: 4,
			description: 'Listo para retiro',
		},
		{
			status: 5,
			description: 'Pedido en camino',
		},
		{
			status: 6,
			description: 'Pedido entregado',
		},
		{
			status: 8,
			description: 'Pedido anulado',
		},
		{
			status: 9,
			description: 'Pedido confirmado',
		},

	],
	CLANICX: [
		{
			status: 1,
			description: 'Por aprobar',
		},
		{
			status: 101,
			description: 'En mediación',
		},
		{
			status: 2,
			description: 'Aprobada',
		},
		{
			status: 201,
			description: 'Por confirmar',
		},
		{
			status: 3,
			description: 'En Proceso de empacado',
		},
		{
			status: 4,
			description: 'Listo para retiro',
		},
		{
			status: 5,
			description: 'Pedido en camino',
		},
		{
			status: 6,
			description: 'Pedido entregado',
		},
		{
			status: 8,
			description: 'Pedido anulado',
		},
		{
			status: 9,
			description: 'Pedido confirmado',
		},

	],
	CLGREEN: [
		{
			status: 1,
			description: 'Por aprobar',
		},
		{
			status: 101,
			description: 'En mediación',
		},
		{
			status: 2,
			description: 'Aprobada',
		},
		{
			status: 201,
			description: 'Por confirmar',
		},
		{
			status: 3,
			description: 'En Proceso de empacado',
		},
		{
			status: 4,
			description: 'Listo para retiro',
		},
		{
			status: 5,
			description: 'Pedido en camino',
		},
		{
			status: 6,
			description: 'Pedido entregado',
		},
		{
			status: 8,
			description: 'Pedido anulado',
		},
		{
			status: 9,
			description: 'Pedido confirmado',
		},

	],
	CLZUPHARMA: [
		{
			status: 1,
			description: 'Por aprobar',
		},
		{
			status: 101,
			description: 'En mediación',
		},
		{
			status: 2,
			description: 'Aprobada',
		},
		{
			status: 201,
			description: 'Por confirmar',
		},
		{
			status: 3,
			description: 'En Proceso de empacado',
		},
		{
			status: 4,
			description: 'Listo para retiro',
		},
		{
			status: 5,
			description: 'Pedido en camino',
		},
		{
			status: 6,
			description: 'Pedido entregado',
		},
		{
			status: 8,
			description: 'Pedido anulado',
		},
		{
			status: 9,
			description: 'Pedido confirmado',
		},

	],
	MX: [
		{
			status: 1,
			description: 'Por aprobar',
		},
		{
			status: 101,
			description: 'En mediación',
		},
		{
			status: 2,
			description: 'Aprobada',
		},
		{
			status: 201,
			description: 'Por confirmar',
		},
		{
			status: 3,
			description: 'En Proceso de empacado',
		},
		{
			status: 4,
			description: 'Listo para retiro',
		},
		{
			status: 5,
			description: 'Pedido en camino',
		},
		{
			status: 6,
			description: 'Pedido entregado',
		},
		{
			status: 8,
			description: 'Pedido anulado',
		},
		{
			status: 9,
			description: 'Pedido confirmado',
		},

	],
};
export const v2_pages_tracking_order_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement = {
	AR: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Envío a Domicilio',
	},
	CL: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLNARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLANICX: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLGREEN: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
	CLZUPHARMA: {
		farmacia: 'Retiro en Farmacia',
		domicilio: 'Despacho a Domicilio',
	},
};
export const v2_pages_tracking_order_detail_constants_delete_products_status_constant__deleteProductStatus = {
	AR: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CL: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CLNARMA: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CLANICX: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CLGREEN: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	CLZUPHARMA: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
	MX: {
		1: 1,
		// 101: 101, TODO REVISAR EL BACK PARA QUE ACEPTE ELIMINAR PRODUCTOS EN ESTE ESTADO
		2: 2,
		201: 201,
	},
};
export const v2_pages_tracking_order_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns = {
	AR: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'CUIL',
		rut: 'DNI',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'
	},
	CL: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLNARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLANICX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLGREEN: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	CLZUPHARMA: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'RUT',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Entidad federativa',
		commune: 'Asentamiento',
		city: 'Ciudad',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
	MX: {
		first_name: 'Nombre',
		last_name: 'Apellido',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		sex: 'Género',
		rfc: 'RFC',
		rut: 'CURP',
		street: 'Calle',
		street_number: 'N° de calle',
		between_street: 'Calle referencial',
		type_house: 'Tipo de vivienda',
		province: 'Estado',
		commune: 'Municipio',
		zip_code: 'Código postal',
		country: 'Pais',
		reference: 'Referencia',
		cfdi: 'CFDI',
		colony: 'Colonia',
		number_dpto_house:'Número de departamento'


	},
};
export const v2_pages_tracking_order_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn = {
	AR: {
		name: 'Nombre',
		lastname: 'Apellido',
		document: 'Dni',
		email: 'Email',
		gender: 'Género',
		status: 'Status',
		phone:'Teléfono'
	},
	CL: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	MX: { name: 'Nombre', lastname: 'Apellido', document: 'Curp', email: 'Email', gender: 'Género', status: 'Status',phone:'Teléfono' },
	CLNARMA: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLANICX: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLGREEN: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },
	CLZUPHARMA: { name: 'Nombre', lastname: 'Apellido', document: 'Rut', email: 'Email', gender: 'Género', status: 'Status', phone: 'Teléfono' },

};
export const v2_pages_tracking_order_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn = {
	AR: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	CL: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
		CLNARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
		CLANICX: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
		CLGREEN: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
		CLZUPHARMA: {
		region: 'Región',
		commune: 'Comuna',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
	},
	MX: {
		region: 'Estado',
		commune: 'Colonia',
		address: 'Dirección',
		phone: 'Teléfono de contacto',
		hometype: 'Tipo de vivienda',
		floor: 'Piso/dpto./torre',
		reference: 'Referencia',
		zip_code: 'Cod. postal',
		municipality: 'Municipio',
	},
};
export const v2_pages_tracking_order_detail_constants_dictionary_information_constant__dictionaryInformation = {
	AR: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'
	},
	CL: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
		CLNARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
		CLANICX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
		CLGREEN: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
		CLZUPHARMA: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
	MX: {
		deliveryinfo: 'Información de entrega en farmacia',
		home_delivery: 'Información de envío a domicilio',
		client: 'Información del cliente',
		order: 'Información del pedido',
		payment: 'Información del pago',
		products: 'Productos',
		stock: 'Revisión de stock',
		billing:'Información de facturación'

	},
};
export const v2_pages_tracking_order_detail_constants_dictionary_order_detail_columns_constant__dictionaryOrderDetailColumn = {
	AR: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
		preorder_id: 'N° de Pre-orden',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
	},
	CL: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
		preorder_id: 'N° de Pre-orden',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
	},
	CLNARMA: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
		preorder_id: 'N° de Pre-orden',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
	},
	CLANICX: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
		preorder_id: 'N° de Pre-orden',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
	},
	CLGREEN: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
		preorder_id: 'N° de Pre-orden',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
	},
	CLZUPHARMA: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
		preorder_id: 'N° de Pre-orden',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
	},
	MX: {
		trx_id: 'ID tracking',
		operation_id: 'N° de solicitud',
		date_order: 'Fecha de pedido',
		schedule_selected: 'Fecha estimada de entrega',
		preorder_id: 'N° de Pre-orden',
		order_id: 'N° de Orden',
		quotation_id: 'N° de Cotización',
	},
};
export const v2_pages_tracking_order_detail_constants_dictionary_payment_columns_contant__dictionaryPaymentColumn = {
	AR: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CL: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLNARMA: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLANICX: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLGREEN: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	CLZUPHARMA: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
	MX: {
		payment_way: 'Forma de pago',
		payment_date: 'Fecha de pago',
		total_products: 'Total productos',
		total_general: 'Total general',
		status: 'Estado',
		pos: 'POS-ID',
		token: 'Token',
		total_delivery: 'Total envío',
	},
};
export const v2_pages_tracking_order_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn = {
	AR: {
		name: 'Nombre',
		quantity: 'Cantidad',
		unit_price: 'Precio u.',
		disscount: 'Descuento u.',
		total: 'Precio final u.',
		recipe: 'Receta',
		actions:'Acciones'
	},
	CL: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', final_price_unit: 'Precio final u.', disscount: 'Descuento u.', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	MX: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', final_price_unit: 'Precio final u.', disscount: 'Descuento u.', total: 'Precio final', recipe: 'Receta', actions:'Acciones' },
	CLNARMA: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', final_price_unit: 'Precio final u.', disscount: 'Descuento u.', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLANICX: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', final_price_unit: 'Precio final u.', disscount: 'Descuento u.', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLGREEN: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', final_price_unit: 'Precio final u.', disscount: 'Descuento u.', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },
	CLZUPHARMA: { name: 'Nombre', quantity: 'Cantidad', unit_price: 'Precio u.', final_price_unit: 'Precio final u.', disscount: 'Descuento u.', total: 'Precio final', recipe: 'Receta', actions: 'Acciones' },

};
export const v2_pages_tracking_order_detail_constants_only_recipe_constant__onlyRecipe = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
	},
	CL: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_tracking_order_detail_constants_product_constant__Product = {
	AR: {
		RMRSCS: 'RMRSCS', // Venta bajo receta archivada
		WP: 'WP', // Venta Bajo Receta
		NP: 'NP', // Venta Libre
		PM: 'PM', // Producto Masivo
		mecanicDiscountOff: 'X % Descuento',
		mecanicNxM: 'N x M',
	},
	CL: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLNARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLANICX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLGREEN: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	CLZUPHARMA: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
	MX: {
		NP: 'NP', //Productos de venta directa
		WP: 'WP', //Productos de presentación de receta
		APR: 'APR', //Productos de presentación de receta antimicrobianos
		MRE: 'MRE', //Productos de presentación de receta que contengan algun psicotrópico
		RMRSCS: 'RMRSCS', //Procutos de receta médica retenida sin control de stock
		RMRCCS: 'RMRCSS', //Productos de receta retenida con control de stock
	},
};
export const v2_pages_tracking_order_detail_constants_status_adapter_constant__statusAdapter = {
	AR: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CL: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLNARMA: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLANICX: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLGREEN: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	CLZUPHARMA: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
	MX: {
		1: '002',
    2: '201',
    101:'002',
		201: '003',
		3: '004',
		4: '006',
	},
};
export const v2_pages_tracking_orders_list_constants_column_titles_constant__ColumnTitles = {
	CL: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		quotation_id: 'N° de cotización',
		preorder_id: 'N° de pre-orden',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	CLNARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		quotation_id: 'N° de cotización',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		preorder_id: 'N° de pre-orden',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	CLANICX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		quotation_id: 'N° de cotización',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		preorder_id: 'N° de pre-orden',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	CLGREEN: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		quotation_id: 'N° de cotización',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		preorder_id: 'N° de pre-orden',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	CLZUPHARMA: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		quotation_id: 'N° de cotización',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		preorder_id: 'N° de pre-orden',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
	MX: {
		trx_id: 'N° de orden',
		operation_id: 'N° de solicitud',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},

	AR: {
		trx_id: 'N° de orden',
		operation_id: 'N° de reserva',
		pharmacy:'Farmacia',
		delivery_type: 'Tipo de entrega',
		status: 'Status',
		createdAt: 'Fecha y hora',
    url_voucher: 'Voucher',
    detailOrder:'Detalle'
	},
};
export const v2_pages_tracking_orders_list_constants_dictionary_constant__Dictionary = {
	CL: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLNARMA: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLANICX: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLGREEN: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	CLZUPHARMA: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	MX: {
		pending: 'Pendiente',
		to_deliver: 'Despachado',
		delivered: 'Entregado',
		rejected: 'Rechazado',
		region: 'Región',
		commune: 'Comuna',
		Rut: 'RUT',
	},
	AR: {
		pending: 'Pendiente',
		to_deliver: 'Por entregar',
		delivered: 'Entregada',
		rejected: 'Rechazado',
		region: 'Partido',
		Commune: 'Localidad',
		RUT: 'DNI',
	},
};
export const v2_pages_tracking_orders_list_constants_status_constant__statusPreparation = {
	AR: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de armado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CL: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CLNARMA: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CLANICX: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CLGREEN: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	CLZUPHARMA: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
	MX: {
		all: 'Todos',
		'001': 'Por aprobar',
		'002': 'Aprobada',
		'003': 'En proceso de empacado',
		'101': 'En Mediación',
		'201': 'Por confirmar',
	},
};
export const v2_pages_tracking_orders_list_constants_status_description_constant__statusDescription = {
	AR: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CL: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CLNARMA: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CLANICX: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CLGREEN: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	CLZUPHARMA: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
	MX: {
		1: 'Por aprobar',
		101: 'En mediación',
		2: 'Aprobada',
		201: 'Por confirmar',
		3: 'En proceso de armado',
		4: 'Listo para retiro',
		5: 'Pedido en camino',
		6: ' Pedido entregado',
		8: 'Pedido cancelado',
		9: 'Entrega confirmada',
	},
};
export const v2_pages_tracking_orders_list_constants_type_delivery_constant__typeDelivery = {
	AR: {
		all:'Todas',
		pharmacy: 'Retiro en farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CL: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLNARMA: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLANICX: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLGREEN: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	CLZUPHARMA: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
	MX: {
		all:'Todas',
		pharmacy: 'Farmacia',
		home: 'Envío a domicilio',
		mixed: 'Mixto',
	},
};

export const COUNTRY_CONFIG = {
	components_Antd_Alert_constants_style_constant__Dictionary,
	components_Antd_Badge_constants_style_constant__Dictionary,
	components_Antd_CheckBox_constants_style_constant__Dictionary,
	components_Antd_CustomRadioGroup_constants_dictionary__Dictionary,
	components_Antd_InputNumber_constants_style_constant__Dictionary,
	components_Antd_Modal_constants_style_constant__Dictionary,
	components_Antd_Search_constants_style_constant__Dictionary,
	components_Antd_Switch_constants_dictionary_constant__Dictionary,
	components_Antd_Table_dictionary__Dictionary,
	components_Antd_Tabs_dictionary__Dictionary,
	components_Antd_TextArea_constants_dictionary_constant__Dictionary,
	config_constants_image_country_constant__CountryImage,
	config_constants_select_all_constant__SelectAll,
	config_constants_status_order_constant__StatusOrder,
	config_functions_format_number_function__FormatNumber,
	config_functions_transform_iso__TransformIso,
	config_functions_transform_unix__TransformUnix,
	v2_components_Antd_Alert_constants_style_constant__Dictionary,
	v2_components_Antd_Badge_constants_style_constant__Dictionary,
	v2_components_Antd_Button_constants_style_constant__Dictionary,
	v2_components_Antd_Checkbox_constants_style_constant__Dictionary,
	v2_components_Antd_Modal_constants_style_constant__Dictionary,
	v2_components_Antd_Pagination_dictionary__Dictionary,
	v2_components_Antd_Radio_constants_style_constant__Dictionary,
	v2_components_Antd_RadioGroup_dictionary__Dictionary,
	v2_components_Antd_Table_dictionary__Dictionary,
	v2_components_Antd_Tabs_dictionary__Dictionary,
	v2_components_Antd_TextArea_dictionary__Dictionary,
	v2_components_Search_country__Country,
	v2_components_SideBar_constants_country_constant__Country,
	v2_pages_admin_carousel_carousel_constants_select_options_constant__selectOptions,
	v2_pages_admin_carousel_carousel_constants_select_options_marketplace_constant__selectOptionsMarket,
	v2_pages_admin_carousel_constants_select_all_constant__SelectAll,
	v2_pages_admin_landing_constants_select_options_constant__selectOptions,
	v2_pages_admin_letters_constants_select_all_constant__SelectAll,
	v2_pages_admin_letters_constants_select_options_constant__selectOptions,
	v2_pages_admin_letters_constants_select_options_marketplace_constant__selectOptionsMarket,
	v2_pages_admin_migration_constants_dictionary_constant__dictionary,
	v2_pages_admin_migration_constants_messages_constant__messages,
	v2_pages_admin_migration_constants_options_marketplace_constant__optionsMarketPlace,
	v2_pages_admin_migration_constants_options_pharmacy_constant__optionsPharmacy,
	v2_pages_admin_migration_constants_states_constant__states,
	v2_pages_admin_pharmacy_icons_constants_select_all_constant__SelectAll,
	v2_pages_admin_pharmacy_icons_constants_select_options_constant__selectOptions,
	v2_pages_admin_pharmacy_icons_constants_select_options_marketplace__selectOptionsMarket,
	v2_pages_admin_pharmacy_locals_list_components_ListView_constants_column_titles_constant__columnTitles,
	v2_pages_admin_pharmacy_sliders_constants_select_all_constant__SelectAll,
	v2_pages_admin_pharmacy_sliders_constants_select_options_constant__selectOptions,
	v2_pages_admin_pharmacy_sliders_constants_select_options_marketplace__selectOptionsMarket,
	v2_pages_admin_qf_criterion_constants_select_all_constant__SelectAll,
	v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_approve_button_constant__approveButton,
	v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_cancel_button_constant__cancelButton,
	v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_confirm_button_constant__confirmButton,
	v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_data_steps_constant__dataSteps,
	v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus,
	v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_payment_method_constants__paymentMethod,
	v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_status_names_constant__statusNames,
	v2_pages_admin_quotation_quotation_detail_components_StatusCard_constants_type_retirement_constant__typeRetirement,
	v2_pages_admin_quotation_quotation_detail_components_TrackingProgress_constants_status_constant__status,
	v2_pages_admin_quotation_quotation_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement,
	v2_pages_admin_quotation_quotation_detail_constants_delete_products_status_constant__deleteProductStatus,
	v2_pages_admin_quotation_quotation_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns,
	v2_pages_admin_quotation_quotation_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn,
	v2_pages_admin_quotation_quotation_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn,
	v2_pages_admin_quotation_quotation_detail_constants_dictionary_information_constant__dictionaryInformation,
	v2_pages_admin_quotation_quotation_detail_constants_dictionary_order_detail_columns_constant__dictionaryOrderDetailColumn,
	v2_pages_admin_quotation_quotation_detail_constants_dictionary_payment_columns_contant__dictionaryPaymentColumn,
	v2_pages_admin_quotation_quotation_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn,
	v2_pages_admin_quotation_quotation_detail_constants_only_recipe_constant__onlyRecipe,
	v2_pages_admin_quotation_quotation_detail_constants_product_constant__Product,
	v2_pages_admin_quotation_quotation_detail_constants_status_adapter_constant__statusAdapter,
	v2_pages_admin_quotation_quotation_list_constants_column_titles_constant__ColumnTitles,
	v2_pages_admin_quotation_quotation_list_constants_dictionary_constant__Dictionary,
	v2_pages_admin_quotation_quotation_list_constants_status_constant__statusPreparation,
	v2_pages_admin_quotation_quotation_list_constants_status_description_constant__statusDescription,
	v2_pages_admin_quotation_quotation_list_constants_type_delivery_constant__typeDelivery,
	v2_pages_admin_report_components_ProductReport_constants_language_constant__Language,
	v2_pages_admin_report_constants_language_constant__Language,
	v2_pages_admin_reserve_reserve_list_constants_column_titles_constant__ColumnTitles,
	v2_pages_admin_reserve_reserve_list_constants_status_names_constant__statusNames,
	v2_pages_admin_stock_constants_select_all_constant__SelectAll,
	v2_pages_admin_tracking_orders_list_constants_column_titles_constant__ColumnTitles,
	v2_pages_admin_tracking_orders_list_constants_dictionary_constant__Dictionary,
	v2_pages_admin_tracking_orders_list_constants_status_constant__statusPreparation,
	v2_pages_admin_tracking_orders_list_constants_status_description_constant__statusDescription,
	v2_pages_admin_tracking_orders_list_constants_type_delivery_constant__typeDelivery,
	v2_pages_carousel_carousel_constants_select_options_constant__selectOptions,
	v2_pages_carousel_carousel_constants_select_options_marketplace_constant__selectOptionsMarket,
	v2_pages_carousel_constants_select_all_constant__SelectAll,
	v2_pages_landing_constants_select_options_constant__selectOptions,
	v2_pages_letters_constants_select_all_constant__SelectAll,
	v2_pages_migration_constants_messages_constant__messages,
	v2_pages_migration_constants_options_constant__Options,
	v2_pages_migration_constants_states_constant__states,
	v2_pages_notification_notifications_list_constants_select_options_constant__selectOptions,
	v2_pages_pharmacy_icons_constants_select_all_constant__SelectAll,
	v2_pages_pharmacy_icons_constants_select_options_constant__selectOptions,
	v2_pages_pharmacy_icons_constants_select_options_marketplace__selectOptionsMarket,
	v2_pages_pharmacy_locals_list_components_ListView_constants_column_titles_constant__columnTitles,
	v2_pages_pharmacy_sliders_constants_select_all_constant__SelectAll,
	v2_pages_preorder_preorder_detail_components_StatusCard_constants_approve_button_constant__approveButton,
	v2_pages_preorder_preorder_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus,
	v2_pages_preorder_preorder_detail_components_StatusCard_constants_link_order_button_constant__linkOrderButton,
	v2_pages_preorder_preorder_detail_components_StatusCard_constants_status_names_constant__statusNames,
	v2_pages_preorder_preorder_detail_components_TrackingProgress_constants_status_constant__status,
	v2_pages_preorder_preorder_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement,
	v2_pages_preorder_preorder_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns,
	v2_pages_preorder_preorder_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn,
	v2_pages_preorder_preorder_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn,
	v2_pages_preorder_preorder_detail_constants_dictionary_information_constant__dictionaryInformation,
	v2_pages_preorder_preorder_detail_constants_dictionary_order_columns_constant__dictionaryOrderColumn,
	v2_pages_preorder_preorder_detail_constants_dictionary_payment_columns_constant__dictionaryPaymentColumn,
	v2_pages_preorder_preorder_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn,
	v2_pages_preorder_preorder_detail_constants_only_recipe_constant__onlyRecipe,
	v2_pages_preorder_preorder_detail_constants_product_constant__Product,
	v2_pages_preorder_preorder_list_constants_column_titles_constant__ColumnTitles,
	v2_pages_preorder_preorder_list_constants_dictionary_constant__Dictionary,
	v2_pages_preorder_preorder_list_constants_status_constant__statusPreparation,
	v2_pages_qf_criterion_constants_select_all_constant__SelectAll,
	v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_approve_button_constant__approveButton,
	v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_cancel_button_constant__cancelButton,
	v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_confirm_button_constant__confirmButton,
	v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_data_steps_constant__dataSteps,
	v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus,
	v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_payment_method_constants__paymentMethod,
	v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_status_names_constant__statusNames,
	v2_pages_quotation_deprecated_quotation_detail_components_StatusCard_constants_type_retirement_constant__typeRetirement,
	v2_pages_quotation_deprecated_quotation_detail_components_TrackingProgress_constants_status_constant__status,
	v2_pages_quotation_deprecated_quotation_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement,
	v2_pages_quotation_deprecated_quotation_detail_constants_delete_products_status_constant__deleteProductStatus,
	v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns,
	v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn,
	v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn,
	v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_information_constant__dictionaryInformation,
	v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_order_detail_columns_constant__dictionaryOrderDetailColumn,
	v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_payment_columns_contant__dictionaryPaymentColumn,
	v2_pages_quotation_deprecated_quotation_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn,
	v2_pages_quotation_deprecated_quotation_detail_constants_only_recipe_constant__onlyRecipe,
	v2_pages_quotation_deprecated_quotation_detail_constants_product_constant__Product,
	v2_pages_quotation_deprecated_quotation_detail_constants_status_adapter_constant__statusAdapter,
	v2_pages_quotation_deprecated_quotation_list_constants_column_titles_constant__ColumnTitles,
	v2_pages_quotation_deprecated_quotation_list_constants_dictionary_constant__Dictionary,
	v2_pages_quotation_deprecated_quotation_list_constants_status_constant__statusPreparation,
	v2_pages_quotation_deprecated_quotation_list_constants_status_description_constant__statusDescription,
	v2_pages_quotation_deprecated_quotation_list_constants_type_delivery_constant__typeDelivery,
	v2_pages_quotation_quotation_detail_components_StatusCard_constants_approve_button_constant__approveButton,
	v2_pages_quotation_quotation_detail_components_StatusCard_constants_cancel_button_constant__cancelButton,
	v2_pages_quotation_quotation_detail_components_StatusCard_constants_confirm_button_constant__confirmButton,
	v2_pages_quotation_quotation_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus,
	v2_pages_quotation_quotation_detail_components_StatusCard_constants_link_order_button_constant__linkOrderButton,
	v2_pages_quotation_quotation_detail_components_StatusCard_constants_new_quotation_button_constant__newQuotationButton,
	v2_pages_quotation_quotation_detail_components_StatusCard_constants_paid_quotation_button_constant__paidQuotationButton,
	v2_pages_quotation_quotation_detail_components_StatusCard_constants_status_names_constant__statusNames,
	v2_pages_quotation_quotation_detail_components_StatusCard_constants_type_retirement_constant__typeRetirement,
	v2_pages_quotation_quotation_detail_components_TrackingProgress_constants_status_constant__status,
	v2_pages_quotation_quotation_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement,
	v2_pages_quotation_quotation_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns,
	v2_pages_quotation_quotation_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn,
	v2_pages_quotation_quotation_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn,
	v2_pages_quotation_quotation_detail_constants_dictionary_information_constant__dictionaryInformation,
	v2_pages_quotation_quotation_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn,
	v2_pages_quotation_quotation_detail_constants_only_recipe_constant__onlyRecipe,
	v2_pages_quotation_quotation_detail_constants_product_constant__Product,
	v2_pages_quotation_quotation_list_constants_column_titles_constant__ColumnTitles,
	v2_pages_quotation_quotation_list_constants_dictionary_constant__Dictionary,
	v2_pages_quotation_quotation_list_constants_status_constant__statusPreparation,
	v2_pages_report_components_ProductReport_constants_language_constant__Language,
	v2_pages_report_constants_language_constant__Language,
	v2_pages_reserve_reserve_detail_components_DropdownTable_constants_product_detail_constant__productDetail,
	v2_pages_reserve_reserve_detail_components_DropdownTable_constants_status_constant__status,
	v2_pages_reserve_reserve_detail_components_ReserveProgress_handle_type_retirement_handle__typeRetirement,
	v2_pages_reserve_reserve_detail_components_StatusCard_constants_notifications_constant__notifications,
	v2_pages_reserve_reserve_detail_components_StatusCard_constants_options_constant__options,
	v2_pages_reserve_reserve_detail_components_StatusCard_constants_status_names_constant__statusNames,
	v2_pages_reserve_reserve_detail_constants_data_steps_constant__dataSteps,
	v2_pages_reserve_reserve_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn,
	v2_pages_reserve_reserve_detail_constants_dictionary_constant__Dictionary,
	v2_pages_reserve_reserve_detail_constants_dictionary_coverage_columns_constant__dictionaryCoverageColumn,
	v2_pages_reserve_reserve_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryColumn,
	v2_pages_reserve_reserve_detail_constants_dictionary_information_constant__dictionaryInformation,
	v2_pages_reserve_reserve_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn,
	v2_pages_reserve_reserve_detail_constants_notifications_constant__notifications,
	v2_pages_reserve_reserve_detail_constants_only_recipe_constant__onlyRecipe,
	v2_pages_reserve_reserve_list_constants_column_titles_constant__ColumnTitles,
	v2_pages_reserve_reserve_list_constants_status_names_constant__statusNames,
	v2_pages_stock_constants_select_all_constant__SelectAll,
	v2_pages_tracking_order_detail_components_DropdownTable_constants_product_detail_constant__productDetail,
	v2_pages_tracking_order_detail_components_DropdownTable_constants_status_constant__status,
	v2_pages_tracking_order_detail_components_RecipeModal_constants_select_constant__selectConstants,
	v2_pages_tracking_order_detail_components_RecipeModal_constants_select_qf_constant__selectQfConstants,
	v2_pages_tracking_order_detail_components_StatusCard_constants_approve_button_constant__approveButton,
	v2_pages_tracking_order_detail_components_StatusCard_constants_cancel_button_constant__cancelButton,
	v2_pages_tracking_order_detail_components_StatusCard_constants_confirm_button_constant__confirmButton,
	v2_pages_tracking_order_detail_components_StatusCard_constants_data_steps_constant__dataSteps,
	v2_pages_tracking_order_detail_components_StatusCard_constants_hide_button_status_constant__hideButtonStatus,
	v2_pages_tracking_order_detail_components_StatusCard_constants_payment_method_constants__paymentMethod,
	v2_pages_tracking_order_detail_components_StatusCard_constants_status_names_constant__statusNames,
	v2_pages_tracking_order_detail_components_StatusCard_constants_type_retirement_constant__typeRetirement,
	v2_pages_tracking_order_detail_components_TrackingProgress_constants_status_constant__status,
	v2_pages_tracking_order_detail_components_TrackingProgress_handle_type_retirement_handle__typeRetirement,
	v2_pages_tracking_order_detail_constants_delete_products_status_constant__deleteProductStatus,
	v2_pages_tracking_order_detail_constants_dictionary_billing_columns_constant__dictionaryBillingColumns,
	v2_pages_tracking_order_detail_constants_dictionary_client_columns_constant__dictionaryClientColumn,
	v2_pages_tracking_order_detail_constants_dictionary_delivery_columns_constant__dictionaryDeliveryInfoColumn,
	v2_pages_tracking_order_detail_constants_dictionary_information_constant__dictionaryInformation,
	v2_pages_tracking_order_detail_constants_dictionary_order_detail_columns_constant__dictionaryOrderDetailColumn,
	v2_pages_tracking_order_detail_constants_dictionary_payment_columns_contant__dictionaryPaymentColumn,
	v2_pages_tracking_order_detail_constants_dictionary_product_columns_constant__dictionaryProductColumn,
	v2_pages_tracking_order_detail_constants_only_recipe_constant__onlyRecipe,
	v2_pages_tracking_order_detail_constants_product_constant__Product,
	v2_pages_tracking_order_detail_constants_status_adapter_constant__statusAdapter,
	v2_pages_tracking_orders_list_constants_column_titles_constant__ColumnTitles,
	v2_pages_tracking_orders_list_constants_dictionary_constant__Dictionary,
	v2_pages_tracking_orders_list_constants_status_constant__statusPreparation,
	v2_pages_tracking_orders_list_constants_status_description_constant__statusDescription,
	v2_pages_tracking_orders_list_constants_type_delivery_constant__typeDelivery,
};
